import { Component, inject, ViewContainerRef } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationStart } from '@angular/router';
import { Overlay, ToastrService } from 'ngx-toastr';
import {
  Observable,
  startWith,
  map,
  concatMap,
  of,
  forkJoin,
  catchError,
  throwError,
} from 'rxjs';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { FdaService } from 'src/app/shared/service/disbursment/fda.component.service';
import { FileUploadService } from 'src/app/shared/service/disbursment/file-upload.service';
import { PdaService } from 'src/app/shared/service/disbursment/pda.component.service';
import { PortAgentFormService } from 'src/app/shared/service/disbursment/port-agent-form.service';
import { PortService } from 'src/app/shared/service/disbursment/port.service';
import { MaCargo } from '../dis-repository/pages/create-cargo/cargo.model';
import { MaClient } from '../dis-repository/pages/create-client/client.model';
import { MaVessel } from '../dis-repository/pages/create-client/vessel.model';
import { MaPortAgent } from '../dis-repository/pages/create-port-agent/port-agent.model';
import { ConfirmationDialogComponent } from '../dis-repository/pages/create-port-tariff/confirmation-dialog.component';
import { MaCountry } from '../dis-repository/pages/create-port-tariff/country.model';
import { MaPort } from '../dis-repository/pages/create-port-tariff/port.model';
import { MaPurpose } from '../dis-repository/pages/create-purpose/purpose.model';
import { EmailSentNotificationComponent } from '../pda/email-sent-notification/email-sent-notification.component';
import {
  AddedFields,
  getMainServiceSerialNumber,
  restrictDecimal,
  getOptionValuefortheFields,
  displayFn,
  onTotalFocus,
  onTotalBlur,
  _filterCurrency,
  formatServices,
  addAdditionalFieldsToFieldsArray,
  displayClientComment,
  mergeResponseVesselIntoList,
  getCurrencyFromCountry,
  filterServicesOnPurpose,
  removeAddedFieldsAndControls,
  getPurposeName,
  formatToLocalISOString,
  getAdditionalPropertiesObjectFromForm,
  replaceMovementPart,
} from '../pda/pda.model';
import { CommunicationHistory } from './comm-history.component.model';
import { ApprovalRequestDialogComponent } from '../fda/approval-request-dialog/approval-request-dialog.component';
import { convertVesselStayToMinutes, fdaFields, PA_Item, PA_Rules, SubService } from '../pda/port-agent-form.model';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { FileUploadDisComponent } from '../pda-edit/file-upload-dis/file-upload-dis.component';

@Component({
  selector: 'app-fda-edit',
  templateUrl: './fda-edit.component.html',
  styleUrls: ['./fda-edit.component.scss'],
})
export class FdaEditComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  displayedColumns: string[] = [
    'S.No',
    'Service',
    'System Value',
    'Agent Value',
    'Agreed / Negotiate',
  ];
  canDeleteService: { [key: string]: boolean } = {};
  hasInitializedExpansion = false;
  portAgentForm!: FormGroup;
  datasource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  PDAdataSource: any = [];
  countryList: MaCountry[] = [];
  portList: MaPort[] = [];
  vesselList: MaVessel[] = [];
  allVesselList: MaVessel[] = [];
  purposeList: MaPurpose[] = [];
  cargoList: MaCargo[] = [];
  clientList: MaClient[] = [];
  currencyList: string[] = [];
  portAgentList: MaPortAgent[] = [];
  filteredOptions: { [key: string]: any[] } = {};
  fields: any[] = fdaFields.map((field: any) => {
    if (field.name === 'Vessel') {
      return { ...field, value: 'vessel_id' };
    }
    return field;
  });
  modFields = this.fields;
  serviceList: PA_Rules = new PA_Rules();
  fdaEditData: any = null;
  merakiServiceList: PA_Rules = new PA_Rules();
  mergedServiceList: any = [];
  agentServiceGrandTotal: number | null = null;
  agentCurrencyCoversion = 0;
  agentServiceTotal = 0;
  merakiServiceTotal = 0;
  merakiServiceGrandTotal: number | null = null;
  pdaRemittance: number | null = null;
  addedFields: AddedFields[] = [];
  disableTableInputFields: boolean = false;
  portAgentReturnMessage: string = '';
  displayAgreedAndNegotiateColumn: boolean = false;
  isNegotiateSelected: boolean = false;
  dis_id: string | null = sessionStorage.getItem('disbursement_seq');
  copyOfMasterData: any = {};
  isManualCreation: string | null = null;
  excludedFieldsFlag = [
    'vessel_stay',
    'fda_roe',
    'voyage',
    'imo_number',
    'invoice_ref_no',
    'fda_currency_from',
  ];
  isExcluded = ['type'];
  errMsg: string = '';
  withPda: boolean = false;
  originalFeedback: string | null = null;
  fda_custom_calculation!: FormControl;
  tariffRules: PA_Rules = new PA_Rules();
  portChange: string = 'N';
  portIdValue: number = 0;
  PDAapprovedValue: PA_Rules = new PA_Rules();
  PDAapprovedGrandTotal: number = 0;
  serviceName: any = '';
  fdaStatus: number = 0;
  showFlag: boolean = false;
  portServiceList: PA_Rules = new PA_Rules();
  fileList: any[] = [];
  communicationHistory: CommunicationHistory[] = [];
  previousPurposeId: number | null = null;
  isPurposeInternalChange: boolean = false;
  previousServiceData: any = null;
  ConvertedFromCurrencyList: string[] = [];
  PaymentFromCurrencyList: string[] = [];
  displayConvertedToCurrency: boolean = false;
  filteredPaymentToCurrency: Observable<string[]> = new Observable<string[]>();
  filteredConvertedToCurrency: Observable<string[]> = new Observable<
    string[]
  >();
  convertedToCurrencyValue: string = '';
  isPurposeChanged: boolean = false;
  previousPortId: number | null = null;
  previousCountryId: number | null = null;
  isPortChanged: boolean = false;
  showCurrencyConversionMismatchBanner: boolean = false;
  calculatedCurrencyConversion: string | null = null;
  responseCurrencyConversion: number | null = null;
  isInitialLoad: boolean = true;
  isRefreshingRules: boolean = false; // Flag to track refresh rules scenario
  rulesWereRefreshed: boolean = false; // Flag to track if rules were refreshed for API
  additionalFieldsFromRules: AddedFields[] = []; // To store additional fields from rules for comparison

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private portAgentFormService: PortAgentFormService,
    private snackBar: ToastrService,
    private portService: PortService,
    private pdaService: PdaService,
    private fdaService: FdaService,
    private clientService: ClientService,
    private router: Router,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    private fileUploadService: FileUploadService,
    private requestFormService: RequestFormService,
  ) {
    this.buildPortAgentForm();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.dialog.closeAll();
      }
    });
  }

  // method to build the port agent form
  buildPortAgentForm() {
    this.portAgentForm = this.fb.group({
      client_id: [null, Validators.required],
      portagent_id: [null, Validators.required],
      cargo_id: [null, Validators.required],
      country_id: [null, Validators.required],
      port_id: [null, Validators.required],
      imo_number: [null, [Validators.required, Validators.maxLength(7)]],
      vessel_id: [null],
      vessel: [null, Validators.required],
      nrt: [null, Validators.required],
      grt: [null, Validators.required],
      rgrt: [null],
      loa: [null, Validators.required],
      beam: [null, Validators.required],
      depth: [null, Validators.required],
      type: [''],
      dwt: [null, Validators.required],
      purpose_id: [null, Validators.required],
      eta: [null, [Validators.required]],
      etd: [null, [Validators.required]],
      vessel_stay: [null, Validators.required],
      fda_roe: [null, Validators.required],
      fda_currency_from: [null, Validators.required],
      fda_currency_to: [null, Validators.required],
      voyage: [null, Validators.required],
      serviceList: this.fb.array([] as FormGroup[]),
      conversion_rate: [null, Validators.required],
      currency_conversion: [null],
      credit_note: [null],
      balance_due: [null],
      fda_amount: [null],
      fda_custom_calculation: [false],
      invoice_ref_no: [null, [Validators.required]],
      PDAapprovedValue: this.fb.array([] as FormGroup[]),
      pda_remittance: [null],
      converted_curr_from: [null],
      converted_curr_to: [null],
      conversion_fda_rate: [null],
      pmt_curr_from: [null],
      pmt_curr_to: [null],
    });
  }
  getMainServiceIndex = getMainServiceSerialNumber;
  restrictDecimal = restrictDecimal;
  getOptionValue = getOptionValuefortheFields;
  displayFn = displayFn;
  onTotalFocus = onTotalFocus;
  onTotalBlur = onTotalBlur;

  // Returns the 'services' FormArray from the main form for easy access and manipulation
  get serviceListFormArray(): FormArray {
    return this.portAgentForm.get('serviceList') as FormArray;
  }

  get PDAapprovedValueFormArray(): FormArray {
    return this.portAgentForm.get('PDAapprovedValue') as FormArray;
  }
  modifiedFields: { [key: string]: boolean } = {};

  ngOnInit() {
    this.fda_custom_calculation = this.portAgentForm.get(
      'fda_custom_calculation',
    ) as FormControl;
    this.getAllMasterData();
    this.trackModifiedFieldChanges();
    this.setupAutocomplete();
    this.setupCalculationSubscriptions();
    this.fda_custom_calculation.valueChanges.subscribe((value) => {});

    this.filteredConvertedToCurrency =
      this.setupFilteredCurrency('converted_curr_to');
    this.filteredPaymentToCurrency = this.setupFilteredCurrency('pmt_curr_to');
  }

  private setupFilteredCurrency(controlName: string): Observable<string[]> {
    return this.portAgentForm.controls[controlName].valueChanges.pipe(
      startWith(''),
      map((value) => _filterCurrency(this.currencyList, value)),
    );
  }

  isFieldReadonly(field: any): boolean {
    if (field.name === 'FromCurrency') {
      return true;
    }
    return false;
  }

  // Setup subscriptions to watch for changes in relevant form controls
  private setupCalculationSubscriptions() {
    const form = this.portAgentForm;
    if (!form) return;

    form.get('credit_note')?.valueChanges.subscribe(() => {
      // Only recalculate if status is not completed
      if (this.fdaStatus !== 7) {
        this.recalculateTotals();
      }
    });

    form.get('conversion_rate')?.valueChanges.subscribe(() => {
      // Only recalculate if status is not completed
      if (this.fdaStatus !== 7) {
        this.recalculateTotals();
      }
    });
  }

  // method to highlight the modified fields
  trackModifiedFieldChanges() {
    Object.keys(this.portAgentForm.controls).forEach((field) => {
      this.portAgentForm.get(field)?.valueChanges.subscribe((value) => {
        let originalValue = this.copyOfMasterData[field];

        // Special handling for country_id and port_id
        // if (field === 'country_id' && this.fdaEditData?.fda?.portagent_fda_data?.country) {
        //   originalValue = this.fdaEditData.fda.portagent_fda_data.country.country_id;
        // } else if (field === 'port_id' && this.fdaEditData?.fda?.portagent_fda_data?.port) {
        //   originalValue = this.fdaEditData.fda.portagent_fda_data.port.port_id;
        // }

        const currentVal =
          value === null || value === undefined ? '' : String(value).trim();
        const originalVal =
          originalValue === null || originalValue === undefined
            ? ''
            : String(originalValue).trim();
        this.modifiedFields[field] = currentVal !== originalVal;
      });
    });
  }

  setupAutocomplete(): void {
    this.modFields.forEach((field) => {
      if (field.type === 'select') {
        this.filteredOptions[field.value] = field.options || [];
        this.portAgentForm.get(field.value)?.valueChanges.subscribe((value) => {
          this.filteredOptions[field.value] = this.autoCompleteFilter(
            field,
            value,
          );
        });
      }
    });
  }

  private autoCompleteFilter(field: any, value: string): any[] {
    const filterValue = (value || '').toString().toLowerCase();
    return (field.options || []).filter((opt: any) => {
      const label =
        field.name === 'Cargo'
          ? opt?.type
          : field.name === 'ToCurrency' || field.name === 'FromCurrency'
            ? opt
            : opt?.name;

      return label?.toLowerCase().includes(filterValue);
    });
  }

  getFilteredOptions(field: any): any[] {
    return this.filteredOptions[field.value] || [];
  }

  // method to get the modified fields
  getModifiedFields() {
    const details = this.fdaEditData?.fda?.fda_vessel_details;
    this.modifiedFields = {};
    if (details) {
      Object.keys(details).forEach((key) => {
        this.modifiedFields[key] = !!details[key]?.modified;
      });
    }
  }

  isExcludedFlag(fieldName: string): boolean {
    return this.excludedFieldsFlag.includes(fieldName.toLowerCase());
  }

  isExcludedField(fieldName: string): boolean {
    return this.isExcluded.includes(fieldName.toLowerCase());
  }

  recalculateData() {
    this.merakiServiceList = this.transFormServiceData(
      this.merakiServiceList,
      'merakiData',
    );
    const formData = this.portAgentForm.getRawValue();
    const submitData = this.transformJsonData(formData);
    this.populateServicesFromList();
    this.loader.show();
    ((submitData.fda_custom_calculation = this.fda_custom_calculation.value
      ? 'Y'
      : 'N'),
      delete submitData.fda_save);
    delete submitData.fda_submit;
    const savedPreviousPurposeId = this.previousPurposeId;
    this.fdaService.fdaReCalculate(submitData).subscribe({
      next: (response) => {
        this.fdaEditData.fda.fda_custom_calculation =
          response?.fda_custom_calculation === 'Y';
        if (!savedPreviousPurposeId) {
          this.previousPurposeId = response?.purpose_id;
        }

        this.previousPortId = response?.portagent_fda_data?.port?.port_id;
        this.previousCountryId =
          response?.portagent_fda_data?.country?.country_id;

        // Use updated tariff rules from response if available
        if (response?.port_tariff_rule) {
          this.tariffRules = response.port_tariff_rule;
          this.portServiceList = response.port_tariff_rule;
        } else {
          this.tariffRules = response?.port_tariff_rule;
        }

        const responsePdaServices = response?.pda?.portagent_pda_data?.services;
        if (responsePdaServices) {
          this.PDAapprovedValue = responsePdaServices;
          this.PDAapprovedGrandTotal =
            responsePdaServices?.grand_total ?? this.PDAapprovedGrandTotal;
        }

        const responseAgentServices = response?.portagent_fda_data?.services;
        if (responseAgentServices) {
          this.serviceList = responseAgentServices;
          this.agentServiceGrandTotal = responseAgentServices?.grand_total ?? 0;
          this.agentServiceTotal = responseAgentServices?.service_total ?? 0;
        }

        const responseMerakiServices = response?.meraki_pda_data?.services;
        if (responseMerakiServices) {
          this.merakiServiceList = responseMerakiServices;
          this.merakiServiceTotal = responseMerakiServices?.service_total ?? 0;
          this.merakiServiceGrandTotal =
            responseMerakiServices?.grand_total ?? 0;
        }

        // Use appropriate merge method based on whether we're refreshing rules
        if (this.isRefreshingRules) {
          this.mergedServiceList = this.mergeAllMerakiServicesWithPortAgent(
            this.merakiServiceList,
            this.serviceList,
            this.PDAapprovedValue,
          );
          this.rulesWereRefreshed = true; // Set flag for API call
          this.isRefreshingRules = false; // Reset flag after use
        } else {
          this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
            this.merakiServiceList,
            this.serviceList,
            this.PDAapprovedValue,
          );
        }

        this.hasInitializedExpansion = false;
        this.populateServicesFromList();
        // Update toggle status for all services after recalculation
        this.updateAllToggleStatuses();
        this.isPurposeChanged = false;
        this.isPortChanged = false;
        this.loader.hide();
      },
      error: (err) => {
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  UpdateModifiedMovementToTariifRules() {
    const updatedTariffItems = this.tariffRules?.items?.map(
      (tariffItem: any) => {
        const formService = this.serviceListFormArray.controls
          .map((c) => c.getRawValue())
          .find((s: any) => s.service === tariffItem.service);
        const updatedSubServices = tariffItem.subService?.map(
          (tariffSub: any) => {
            const formSub = formService?.subService?.find(
              (fs: any) =>
                fs.name === tariffSub.name &&
                !fs.unique_key?.includes('System'),
            );
            return {
              ...tariffSub,
              optional: this.isRefreshingRules
                ? tariffSub?.optional === 'Y'
                  ? 'Y'
                  : 'N'
                : formSub?.optional === true || formSub?.optional === 'Y'
                  ? 'Y'
                  : 'N',
              movement: formSub
                ? (() => {
                    if (!tariffSub.movement) return tariffSub.movement;

                    const parts = tariffSub.movement.split(':');
                    while (parts.length < 4) parts.push('NA');

                    // Replace only movement code part
                    parts[1] = formSub.formattedSystemMovement || parts[1];

                    return parts.join(':');
                  })()
                : tariffSub.movement,
            };
          },
        );
        return {
          ...tariffItem,
          subService: updatedSubServices,
        };
      },
    );
    const formattedData = formatServices(updatedTariffItems);
    return { items: formattedData };
  }

  // method to calculate the vessel stay on date change
  onDateChange() {
    const eta = this.portAgentForm.get('eta')?.value;
    const etd = this.portAgentForm.get('etd')?.value;
    const stay = this.calculateVesselStayInFda(eta, etd);

    if (stay === 'eta greater than etd') {
      this.portAgentForm.get('vessel_stay')?.setValue(null);
      this.portAgentForm.get('etd')?.setValue(null);
    } else {
      this.portAgentForm.get('vessel_stay')?.setValue(stay);
    }
  }

  calculateVesselStayInFda = (
    eta: Date | string,
    etd: Date | string,
  ): string | null => {
    if (!eta || !etd) return null;

    const etaDate = new Date(eta);
    let etdDate = new Date(etd);

    if (
      etdDate.getHours() === 0 &&
      etdDate.getMinutes() === 0 &&
      etdDate.getSeconds() === 0
    ) {
      etdDate.setHours(23, 59, 59, 999);
    }

    // Compare only date for validation
    const etaOnly = new Date(
      etaDate.getFullYear(),
      etaDate.getMonth(),
      etaDate.getDate(),
    );
    const etdOnly = new Date(
      etdDate.getFullYear(),
      etdDate.getMonth(),
      etdDate.getDate(),
    );

    if (etdOnly.getTime() < etaOnly.getTime()) {
      return 'eta greater than etd';
    }

    const diffInMs = etdOnly.getTime() - etaOnly.getTime();
    const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMs === 0) {
      return '1D';
    }

    return `${diffDays + 1}D`;
  };

  // methos to swap the fields for IMO Number and Vessel
  swapFields() {
    const imoIndex = this.modFields.findIndex(
      (f) => f.name?.trim() === 'IMO Number',
    );
    const vesselIndex = this.modFields.findIndex(
      (f) => f.name?.trim() === 'Vessel',
    );
    if (imoIndex !== -1 && vesselIndex !== -1) {
      const temp = this.modFields[imoIndex];
      this.modFields[imoIndex] = this.modFields[vesselIndex];
      this.modFields[vesselIndex] = temp;
      this.modFields[imoIndex].type = 'select';
      this.modFields[vesselIndex].type = 'input';
    }
  }

  // method to set the data for the dropdown
  formatFieldData(fields: any[]) {
    fields.forEach((field: any) => {
      switch (field.name.trim()) {
        case 'Country':
          field.options = this.countryList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port Agent':
          field.options = this.portAgentList.map((agent: any) => ({
            portagent_id: agent.company_id,
            name: agent.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Client':
          field.options = this.clientList.map((client: any) => ({
            client_id: client.company_id,
            name: client.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Cargo':
          field.options = this.cargoList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port':
          field.options = this.portList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Vessel':
          field.options = this.vesselList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Purpose':
          field.options = this.purposeList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'ToCurrency':
          field.options = this.currencyList;
          field.type = 'select';
          this.filteredOptions[field.value] = field.options;
          break;
        default:
      }
    });
  }

  // method to filter the ports based on country
  portByCountry(fieldName: string, value: any) {
    if (fieldName === 'Country') {
      this.loader.show();
      this.portService.getPortsByCountryId(value).subscribe({
        next: (ports) => {
          this.portList = ports;
          this.modFields.map((field) => {
            if (field.name === 'Port') {
              field.options = this.portList.map((port: any) => ({
                port_id: port.port_id,
                name: port.name,
              }));
            }
            this.filteredOptions[field.value] = field.options;
            this.portAgentForm
              .get('port_id')
              ?.setValue(this.fdaEditData.fda.portagent_fda_data.port.port_id);
          });
          const port_id = this.portAgentForm.get('port_id')?.value;
          // this.addAdditionalFieldsToFieldsArray(port_id);
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );

          this.loader.hide();
        },
        error: (error: any) => {
          this.portList = [];
          this.loader.hide();
          this.errMsg =
            error?.error?.error ||
            'Something went wrong please try again later.';
          this.snackBar.error(this.errMsg);
        },
      });
    }
  }

  onSubmit(buttonName: string) {
    if (!this.portAgentForm.valid) {
      this.markRequiredTouched(this.portAgentForm);
      this.focusFirstRequiredInvalid(this.portAgentForm);
      this.snackBar.error('Please fill all required fields');
      return;
    }

    const data = {
      disbursement_seq: this.fdaEditData.disbursement_seq,
      pda_fda_flag: 'FDA',
    };
    this.loader.show();
    this.fileUploadService.fileDataFromDb(data).subscribe({
      next: (res) => {
        this.fileList = res;
        if (this.fileList.length === 0) {
          this.snackBar.error('Please upload files before submitting.');
          this.loader.hide();
          return;
        }
        this.loader.hide();
        this.checkAgentValue(buttonName);
      },
      error: (err) => {
        this.loader.hide();
        this.snackBar.error('Error fetching file data.');
      },
    });
  }

  private checkAgentValue(buttonName: string) {
    if (!this.agentServiceGrandTotal || this.agentServiceGrandTotal === 0) {
      if (this.withPda) {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          disableClose: true,
          panelClass: 'sweet-alert-style',
          data: {
            header: 'Warning data',
            text: 'Agent value is not entered. Do you want to use the PDA-approved value as the agent value?',
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.serviceListFormArray.controls.forEach(
              (service: AbstractControl) => {
                const pdaValue = service.get('pdaApprovedTotalValue')?.value;
                service.get('total')?.setValue(pdaValue);
              },
            );
            this.calculateAgentServiceGrandTotal();
            this.proceedWithSubmitDialog(buttonName);
          }
        });
        return;
      } else {
        this.snackBar.error('Please enter the agent value');
        return;
      }
    }

    this.proceedWithSubmitDialog(buttonName);
  }

  private proceedWithSubmitDialog(buttonName: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Submit Data',
        text: "Once submitted, this FDA cannot be edited. If you do not wish to submit now, please click 'Save' to keep it in draft and modify it later.",
        button: 'Save',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'save') {
        this.fdaEditSubmitAndSave('save');
      } else if (result) {
        this.fdaEditSubmitAndSave(buttonName);
      }
    });
  }

  openReRequestEmailDialog(buttonName: string) {
    const clientEmail = this.clientList.filter((client) => {
      return client.company_id === this.portAgentForm.get('client_id')?.value;
    });
    const dialogRef = this.dialog.open(ApprovalRequestDialogComponent, {
      disableClose: true,
      position: { right: '0' },
      panelClass: ['animate__animated', 'animate__slideInRight'],
      width: '95%',
      height: '100%',
      maxWidth: '95vw',
      maxHeight: '100vh',
      data: {
        to: clientEmail[0]?.email || '',
        cc: clientEmail[0]?.email || '',
        services: {
          items: this.mergedServiceList,
          grand_Total: this.agentServiceGrandTotal,
        },
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        const submitData = this.transformJsonData(
          this.portAgentForm.getRawValue(),
        );
        submitData.portagent_fda_data.services = {
          items: data.services,
          grand_total: this.agentServiceGrandTotal,
        };
        this.loader.show();
        this.fdaService.fdaSaveAndSubmit(submitData).subscribe({
          next: (response) => {
            const payload = {
              disbursement_seq: this.fdaEditData.disbursement_seq,
              email_to: data.to,
              email_cc: data.cc,
              meraki_cmt_to_client: data.meraki_comment_to_client,
              email_signature: data.email_signature,
              update_signature: data.update_signature,
            };
            if (buttonName === 'Request Approval') {
              this.pdaService.clientRequestfda(payload).subscribe({
                next: (response) => {
                  this.loader.hide();
                  const dialogRef = this.dialog.open(
                    EmailSentNotificationComponent,
                    {
                      disableClose: true,
                      panelClass: 'email-dialog-style',
                      width: '400px',
                      height: '150px',
                      data: {
                        email: data.to,
                      },
                    },
                  );
                  dialogRef.afterClosed().subscribe((data) => {
                    if (data) {
                      this.router.navigate(['/dis-disbursment']);
                    }
                  });
                },
              });
            }
            this.loader.hide();
          },
          error: (err) => {
            this.loader.hide();
            this.errMsg =
              err?.error?.error ||
              'Something went wrong please try again later.';
            this.snackBar.error(this.errMsg);
          },
        });
      }
    });
  }

  // method to post the pda edit data
  fdaEditSubmitAndSave(buttonName: string) {
    const newRow = this.serviceListFormArray.controls.find(
      (row) => row.get('isNew')?.value,
    );

    if (newRow) {
      const serviceControl = newRow.get('service');
      const serviceValue = serviceControl?.value;

      // If the new row has an empty service name, show error and return
      if (!serviceValue || serviceValue.trim() === '') {
        serviceControl?.markAsTouched();
        serviceControl?.markAsDirty();

        setTimeout(() => {
          const inputElement = document.querySelector<HTMLInputElement>(
            '.service-name.input-error',
          );
          if (inputElement) {
            inputElement.focus();
          }
        }, 0);

        this.snackBar.error(
          'Please fill the newly added row or remove it before saving',
        );
        return;
      }
    }
    // if the button id save or    submit   execute the below code
    else if (buttonName === 'Request Approval') {
      if (this.portAgentForm.valid) {
        const formData = this.portAgentForm.getRawValue();
        const submitData = this.transformJsonData(formData);
        submitData.pda_save = 'Y';
        this.loader.show();
        this.fdaService
          .fdaSaveAndSubmit(submitData)
          .pipe(concatMap(() => this.getFdaEditData()))
          .subscribe({
            next: () => {
              this.openReRequestEmailDialog('Request Approval');
              this.loader.hide();
            },
            error: (error) => {
              this.errMsg =
                error?.error?.error ||
                'Something went wrong, please try again later.';
              this.snackBar.error(this.errMsg);
              this.loader.hide();
            },
          });
      } else {
        this.portAgentForm.markAllAsTouched();
        this.snackBar.error('Please fill all required fields');
      }
    } else {
      this.loader.show();
      this.getUploadedFiles()
        .pipe(
          concatMap((files) => {
            const formData = this.portAgentForm.getRawValue();
            const submitData = this.transformJsonDataToFdaSave(formData);
            submitData.fda_submit = buttonName === 'Submit' ? 'Y' : 'N';
            submitData.fda_save = buttonName === 'save' ? 'Y' : 'N';
            return this.fdaService.fdaSaveAndSubmit(submitData).pipe(
              concatMap((response) => {
                this.snackBar.success(response.message);
                if (buttonName === 'Submit') {
                  this.router.navigate(['/dis-disbursment']);
                  return of(response);
                } else {
                  return forkJoin([
                    this.getFdaEditData(),
                    this.getUploadedFiles(),
                  ]).pipe(map(() => response));
                }
              }),
            );
          }),
        )
        .subscribe({
          next: () => {
            this.loader.hide();
            // Reset the flag after successful API call
            this.rulesWereRefreshed = false;
          },
          error: (err) => {
            this.loader.hide();
            this.errMsg =
              err?.error?.error ||
              'Something went wrong, please try again later.';
            this.snackBar.error(this.errMsg);
          },
        });
    }
  }

  onSave(buttonName: string) {
    const newRow = this.serviceListFormArray.controls.find(
      (row) => row.get('isNew')?.value,
    );

    if (newRow) {
      const serviceControl = newRow.get('service');
      const serviceValue = serviceControl?.value;

      if (!serviceValue || serviceValue.trim() === '') {
        serviceControl?.markAsTouched();
        serviceControl?.markAsDirty();

        setTimeout(() => {
          const inputElement = document.querySelector<HTMLInputElement>(
            '.service-name.input-error',
          );
          if (inputElement) {
            inputElement.focus();
          }
        }, 0);

        this.snackBar.error(
          'Please submit the newly added service or remove it before saving',
        );
        return;
      } else {
        this.snackBar.error(
          'Please submit the newly added service before saving',
        );
        return;
      }
    }
    if (this.isFormValidExcept(['conversion_rate', 'serviceList'])) {
      this.fdaEditSubmitAndSave(buttonName);
    } else {
      Object.keys(this.portAgentForm.controls).forEach((key) => {
        if (['conversion_rate', 'serviceList'].includes(key)) return;

        const control = this.portAgentForm.get(key);
        control?.markAsTouched();
        control?.updateValueAndValidity();
      });

      this.snackBar.error('Please fill all required fields');
    }
  }

  // Recursively mark only required controls as touched
  private markRequiredTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markRequiredTouched(control);
      } else if (control.hasValidator(Validators.required)) {
        control.markAsTouched();
      }
    });
  }

  // Focus first invalid required input
  private focusFirstRequiredInvalid(formGroup: FormGroup | FormArray) {
    const firstInvalidControl: any = document.querySelector(
      'form .ng-invalid[required]',
    );
    if (firstInvalidControl) {
      firstInvalidControl.focus();
    }
  }

  // method to process the serviceList
  private populateServicesFromList() {
    this.serviceListFormArray.clear();
    this.datasource.data = [];
    this.PDAdataSource = [];
    if (this.mergedServiceList && Array.isArray(this.mergedServiceList)) {
      this.mergedServiceList.forEach((item: any) => {
        const subServiceArray = this.fb.array(
          (item.subService || []).map((sub: any) =>
            this.fb.group({
              SNO: [item.SNO],
              name: [sub.name],
              purpose: [sub.purpose],
              basic_value: [sub.basic_value],
              calculated_basic_value: [sub.calculated_basic_value],
              hide: [sub.hide],
              unique_key: [sub.unique_key],
              movement: [sub.movement],
              tariff_percent: [sub.tariff_percent],
              formula_result: [sub.formula_result],
              optional: [sub.optional === 'Y' || sub.optional === true],
              operational_flag: [sub.operational_flag],
              sub_total: [{ value: 0, disabled: this.disableTableInputFields }],
              formula_inputs: [sub.formula_inputs],
              isSubService: [true],
              systemMovement: [sub.systemMovement || 0],
              systemSubTotal: [sub.systemSubTotal || 0],
              systemFormulaInputs: [sub.systemFormulaInputs || []],
              pdaApprovedSubTotalValue: [sub.pdaApprovedSubTotalValue || 0],
              formattedSystemMovement: [sub.systemMovement?.split(':')[1] || 1],
            }),
          ),
        );
        const serviceIndex = this.serviceListFormArray.length;
        const hasSubServices = (item.subService || []).length > 0;
        const mainServiceGroup = this.fb.group({
          SNO: [item.SNO],
          code: [item.code],
          total: [
            {
              value:
                item.total !== null &&
                item.total !== undefined &&
                item.total !== '' &&
                !isNaN(Number(item.total))
                  ? Number(item.total)
                  : null,
              disabled: this.disableTableInputFields,
            },
          ],
          service: [item.service || ''],
          purpose: [item.purpose || ''],
          pa_remark: [item.pa_remark || ''],
          /* ** Needs to be reviewed with Team - PDA comments to be displayed in FDA -- Surjit
           * pa_remark: [item.pa_remark || this.getPdaRemark(item.service) || ''],
           * meraki_feedback: [{ value: item.meraki_feedback || this.getPdaFeedback(item.service) || '', disabled: this.disableTableInputFields }],
           * meraki_remark_client: [item.meraki_remark_client || this.getPdaMerakiRemarkClient(item.service) || ''],
           * client_comment: [item.client_comment || this.getPdaClientComment(item.service) || ''],
           */
          meraki_feedback: [
            {
              value: item.meraki_feedback || '',
              disabled: this.disableTableInputFields,
            },
          ],
          meraki_remark_client: [item.meraki_remark_client || ''],
          client_comment: [item.client_comment || ''],
          client_option: [item.client_option || ''],
          info_msg: [item.info_msg || ''],
          negotiate: [item.negotiate || 'N'],
          agreed: [item.agreed || 'N'],
          display_to_client: [item.display_to_client || 'N'],
          subService: subServiceArray,
          isSubService: [false],
          expanded: [!this.hasInitializedExpansion && hasSubServices],
          agreedOrNegotiate: [
            item.negotiate === 'Y' ? 'Negotiate' : 'Agreed',
            Validators.required,
          ],
          systemTotal: [
            typeof item.systemTotal === 'string' ? 0 : item.systemTotal || 0,
          ],
          pdaApprovedTotalValue: [item.pdaApprovedTotalValue || 0],
          serviceIndex: [serviceIndex],
          formated_client_comment: [
            displayClientComment(item.client_comment) || '',
          ],
        });
        this.serviceListFormArray.push(mainServiceGroup);
      });
    }
    this.updateDatasource();
    this.hasInitializedExpansion = true;
  }

  // method to toggle the services
  toggleRow(service: FormGroup) {
    const isExpanded = service.get('expanded')?.value;
    service.get('expanded')?.setValue(!isExpanded);
    this.updateDatasource();
  }

  // method  to update the data source to display the subservices in the table
  updateDatasource() {
    this.datasource.data = [];
    this.PDAdataSource = [];

    for (let service of this.serviceListFormArray.controls) {
      this.datasource.data.push(service);
      if (service.get('expanded')?.value) {
        const subServiceFormArray = service.get('subService') as FormArray;
        subServiceFormArray.controls.forEach((subServiceCtrl) => {
          this.datasource.data.push(subServiceCtrl);
        });
      }
    }

    for (let pdaService of this.PDAapprovedValueFormArray.controls) {
      this.PDAdataSource.push(pdaService);
      if (pdaService.get('expanded')?.value) {
        const pdaSubServiceFormArray = pdaService.get(
          'subService',
        ) as FormArray;
        pdaSubServiceFormArray.controls.forEach((subServiceCtrl) => {
          this.PDAdataSource.push(subServiceCtrl);
        });
      }
    }

    this.onSelectionChange(null);
  }

  // method to open the add service dialog
  openCreateServiceDialog() {
    const newSNO = this.serviceListFormArray.length + 1;
    const serviceIndex = this.serviceListFormArray.length;
    const control = this.fb.group({
      SNO: [newSNO, { validators: Validators.required }],
      code: ['', { validators: Validators.required }],
      total: [0, { validators: Validators.required }],
      service: ['', { validators: Validators.required }],
      purpose: [''],
      pa_remark: [''],
      meraki_feedback: ['', { validators: Validators.required }],
      meraki_remark_client: [''],
      client_comment: [''],
      formated_client_comment: [''],
      client_option: [''],
      info_msg: [''],
      negotiate: ['N', { validators: Validators.required }],
      agreed: ['N', { validators: Validators.required }],
      subService: this.fb.array([]),
      systemTotal: [0],
      systemSubTotal: [0],
      expanded: [false],
      isNew: [true],
      isSubService: [false],
      pdaTotal: [0],
      agreedOrNegotiate: ['Agreed', Validators.required],
      serviceIndex: [serviceIndex],
    });

    // Add form control names
    Object.keys(control.controls).forEach((key) => {
      const ctrl = control.get(key);
      if (ctrl) {
        (ctrl as any).name = key;
      }
    });

    // Subscribe to service name changes to update delete permissions
    control.get('service')?.valueChanges.subscribe(() => {
      this.checkDeletePermission();
      this.updateDatasource();
    });

    this.serviceListFormArray.push(control);
    this.updateDatasource();
    this.checkDeletePermission();
  }

  deleteService(service: FormGroup) {
    const index = this.serviceListFormArray.controls.indexOf(service);
    if (index === -1) return;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: { header: 'Delete', text: 'Do you want to delete the service?' },
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        this.serviceListFormArray.removeAt(index);
        this.updateDatasource();
        this.checkDeletePermission();
        this.calculateAgentServiceGrandTotal();
      }
    });
  }

  submitServiceName(service: FormGroup) {
    const serviceNameControl = service.get('service');

    if (
      !serviceNameControl ||
      !serviceNameControl.value ||
      serviceNameControl.value.trim() === ''
    ) {
      this.snackBar.error('Please enter a service name');
      return;
    }

    const serviceName = serviceNameControl.value.trim();

    const isDuplicate = this.serviceListFormArray.controls.some((ctrl, idx) => {
      const currentIndex = this.serviceListFormArray.controls.indexOf(service);
      if (idx === currentIndex) return false;

      const existingServiceName = ctrl.get('service')?.value;
      return (
        existingServiceName &&
        existingServiceName.trim().toLowerCase() === serviceName.toLowerCase()
      );
    });

    if (isDuplicate) {
      this.snackBar.error(
        'A service with this name already exists. Please use a different name.',
      );
      return;
    }
    service.get('isNew')?.setValue(false);
    service.markAsPristine();
    service.updateValueAndValidity();

    this.snackBar.success('Service name saved');
    this.updateDatasource();
    this.checkDeletePermission();
  }

  closeNewRow(element: FormGroup): void {
    const index = this.serviceListFormArray.controls.indexOf(element);
    if (index !== -1) {
      this.serviceListFormArray.removeAt(index);
      this.updateDatasource();
    }
  }

  // method to get the all master data
  getAllMasterData(): void {
    this.swapFields();
    this.loader.show();
    const params = {
      fields: ['all'],
    };
    this.portAgentFormService
      .getMasterData(params)
      .pipe(
        concatMap((response: any) => {
          this.countryList = response.country;
          this.purposeList = response.purpose;
          this.portAgentList = response.port_agent;
          this.clientList = response.client;
          this.cargoList = response.cargo;
          this.currencyList = response.currency;
          this.formatFieldData(this.modFields);
          return this.getFdaEditData();
        }),
      )
      .subscribe({
        next: () => {
          this.loader.hide();
        },
        error: (err: any) => {
          this.loader.hide();
          this.errMsg =
            err?.error?.error || 'Something went wrong please try again later.';
          this.snackBar.error(this.errMsg);
        },
      });
  }

  private buildFdaVesselOptions(vessels: any[]) {
    this.allVesselList = vessels || [];
    this.vesselList = this.allVesselList;
    this.modFields.forEach((field) => {
      if (field.name === 'Vessel') {
        field.options = this.allVesselList.map((vessel: any) => ({
          vessel_id: vessel.vessel_id,
          name: vessel.name,
        }));
      }
      this.filteredOptions[field.value] = field.options;
    });
  }

  // method to get the vessel based on the client
  vesselListByClientId(clientId: number): Observable<any> {
    const vslpayload = {
      company_id: clientId,
      fields: ['assigned_unassigned'],
    };
    return this.clientService.VslListFromDb(vslpayload).pipe(
      map((response: any) => {
        const mergedList = mergeResponseVesselIntoList(
          response.assigned_vessels || [],
          this.fdaEditData?.fda?.fda_vessel_details,
        );
        this.buildFdaVesselOptions(mergedList);
        this.portAgentForm
          .get('vessel_id')
          ?.setValue(this.fdaEditData.fda.fda_vessel_details.vessel_id);
        return response;
      }),
      catchError((error: any) => {
        this.vesselList = [];
        this.errMsg = error?.error?.error || 'Failed to fetch vessel details';
        this.snackBar.error(this.errMsg);
        return of(null);
      }),
    );
  }

  // method to get the pda edit data
  getFdaEditData(): Observable<any> {
    return this.pdaService.pdaEditFormData(this.dis_id).pipe(
      concatMap((response: any) => {
        this.communicationHistory = response?.communication_histories;
        this.fdaStatus = response?.fda?.status;
        this.fdaEditData = response;
        this.pdaRemittance = response?.pda?.pda_remittance;
        this.PDAapprovedGrandTotal =
          response?.pda?.portagent_pda_data?.services?.grand_total ?? 0;
        this.portIdValue = response.fda.portagent_fda_data.port?.port_id;
        this.tariffRules = response.port_tariff_rule;
        this.withPda = response.pda !== null;
        const purposeId = response.purpose_id;
        this.previousPurposeId = purposeId;
        this.previousPortId = response.port_id;
        this.previousCountryId = response.country_id;
        this.disableFields(this.withPda, response.return_status);

        // Check if FDA state is 'N' and disable form
        if (response?.fda?.state === 'N') {
          this.portAgentForm.disable();
          this.disableTableInputFields = true;
        }

        const countryId = response.country_id;
        if (countryId) {
          const currency = getCurrencyFromCountry(this.countryList, countryId);
          this.portAgentForm.patchValue({
            fda_currency_from: currency,
          });
        }
        if (this.withPda) {
          if (!this.displayedColumns.includes('PDA Approved Value')) {
            const agentValueIndex =
              this.displayedColumns.indexOf('Agent Value');
            if (agentValueIndex !== -1) {
              this.displayedColumns.splice(
                agentValueIndex,
                0,
                'PDA Approved Value',
              );
            }
          }
        } else {
          this.displayedColumns = this.displayedColumns.filter(
            (col) => col !== 'PDA Approved Value',
          );
        }

        const observables: Observable<any>[] = [];

        if (countryId) {
          observables.push(this.portByCountryObservable(countryId));
        }

        // Skip vessel fetch for completed FDAs (status === 7)
        if (response.fda.status !== 7) {
          observables.push(this.vesselListByClientId(response.client_id));
        }

        // Process other data first
        this.setServiceData(response);
        this.checkDeletePermission();
        this.patchFormValues(response);
        this.getModifiedFields();

        // Calculate currency conversion on initial load
        this.calculateCurrencyConversionForComparison();
        this.checkCurrencyConversionMismatch();

        if (response.fda.status === 7 || response?.fda?.state === 'N') {
          this.portAgentForm.disable();
          this.disableTableInputFields = true;
          const vesselDetails = response.fda.fda_vessel_details;
          const mergedList = mergeResponseVesselIntoList([], vesselDetails);
          this.buildFdaVesselOptions(mergedList);
        } else {
          // For non-completed FDAs, include vessel fetch in observables
        }

        return observables.length > 0
          ? forkJoin(observables).pipe(
              map(() => {
                // Call handleAdditionalFields after port data is loaded and added fields are initialized
                this.handleAdditionalFields(response);
                return response;
              }),
            )
          : of(response).pipe(
              map(() => {
                // Call handleAdditionalFields even when no observables
                this.handleAdditionalFields(response);
                return response;
              }),
            );
      }),
      catchError((err: any) => {
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
        return throwError(() => err);
      }),
    );
  }

  // Helper method for port by country as observable
  private portByCountryObservable(countryId: number): Observable<any> {
    return this.portService.getPortsByCountryId(countryId).pipe(
      map((ports) => {
        this.portList = ports;
        this.modFields.map((field) => {
          if (field.name === 'Port') {
            field.options = this.portList.map((port: any) => ({
              port_id: port.port_id,
              name: port.name,
            }));
          }
          this.filteredOptions[field.value] = field.options;
          this.portAgentForm
            .get('port_id')
            ?.setValue(this.fdaEditData.fda.portagent_fda_data.port.port_id);
        });
        const port_id = this.portAgentForm.get('port_id')?.value;
        this.addedFields = addAdditionalFieldsToFieldsArray(
          port_id,
          this.portList,
          this.fields,
          this.portAgentForm,
          this.addedFields,
          this.filteredOptions,
          this.fb,
        );

        return ports;
      }),
      catchError((error: any) => {
        this.portList = [];
        this.errMsg =
          error?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
        return of([]);
      }),
    );
  }

  // Check if a service exists in port tariff rules
  private checkDeletePermission() {
    this.canDeleteService = {};

    if (!this.tariffRules?.items) {
      this.serviceListFormArray.controls.forEach((_, index) => {
        this.canDeleteService[index] = true;
      });
      return;
    }

    const portTariffServicesMap = new Map(
      (this.tariffRules.items || [])
        .filter(
          (rule) =>
            rule && typeof rule.service === 'string' && rule.service !== null,
        )
        .map((rule) => [rule.service!.trim().toLowerCase(), true]),
    );

    this.serviceListFormArray.controls.forEach((control, index) => {
      this.serviceName = control.get('service')?.value;

      if (!this.serviceName) {
        this.canDeleteService[index] = true;
        return;
      }
      const normalizedServiceName = this.serviceName.trim().toLowerCase();
      const existsInTariffRules = portTariffServicesMap.has(
        normalizedServiceName,
      );
      this.canDeleteService[index] = !existsInTariffRules;
    });
  }

  // Method to check if a specific service can be deleted (not in tariff rules)
  canDeleteSpecificService(service: FormGroup): boolean {
    if (!service) {
      return true;
    }

    const code = service.get('code')?.value;
    if (!code || code === '' || code === null) {
      return true;
    }

    const serviceName = service.get('service')?.value;

    if (!serviceName || serviceName.trim() === '') {
      return true;
    }

    if (!this.tariffRules?.items || this.tariffRules.items.length === 0) {
      return true;
    }

    const normalizedServiceName = serviceName.trim().toLowerCase();
    const existsInTariffRules = this.tariffRules.items.some(
      (rule) =>
        rule &&
        typeof rule.service === 'string' &&
        rule.service !== null &&
        rule.service.trim().toLowerCase() === normalizedServiceName,
    );

    return !existsInTariffRules;
  }

  private setServiceData(response: any): void {
    this.tariffRules = response.port_tariff_rule;

    this.merakiServiceList = response.fda?.meraki_pda_data?.services;
    this.PDAapprovedValue = response.pda?.portagent_pda_data?.services;

    const purpose = response.fda?.portagent_fda_data?.purpose.name;

    this.portServiceList = response.fda?.portagent_fda_data?.services;
    this.serviceList.items = filterServicesOnPurpose(
      purpose,
      this.portServiceList.items,
    );

    this.serviceList.grand_total =
      response.fda?.portagent_fda_data?.services?.grand_total ?? 0;
    this.agentServiceGrandTotal =
      response.fda?.portagent_fda_data?.services?.grand_total ?? 0;
    this.merakiServiceGrandTotal = this.merakiServiceList?.grand_total ?? 0;
    this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
      this.merakiServiceList,
      this.serviceList,
      this.PDAapprovedValue,
    );

    this.populateServicesFromList();

    setTimeout(() => {
      this.checkDeletePermission();
    }, 0);
  }

  private patchFormValues(response: any): void {
    const portAgentFormData = response.fda.portagent_fda_data;
    const vesselDetails = response.fda.fda_vessel_details;
    const customCalcValue = response?.fda?.fda_custom_calculation === 'Y';
    this.fda_custom_calculation = new FormControl(customCalcValue);
    this.portAgentForm.patchValue({
      client_id: response.client_id,
      portagent_id: response.portagent_id,
      cargo_id: portAgentFormData?.cargo?.cargo_id,
      country_id: portAgentFormData?.country?.country_id,
      port_id: portAgentFormData?.port?.port_id,
      imo_number: vesselDetails?.vessel_imo,
      vessel_id: vesselDetails?.vessel_id,
      vessel: vesselDetails?.vessel_name,
      nrt: vesselDetails?.nrt.current,
      grt: vesselDetails?.grt.current,
      rgrt: vesselDetails?.rgrt.current,
      loa: vesselDetails?.loa.current,
      beam: vesselDetails?.beam.current,
      depth: vesselDetails?.depth.current,
      dwt: vesselDetails?.dwt.current,
      type: vesselDetails?.type.current,
      purpose_id: portAgentFormData?.purpose?.purpose_id,
      eta: response?.fda.fda_eta,
      etd: response?.fda.fda_etd,
      vessel_stay: this.convertMinutesToDaysHoursShort(
        response.fda.fda_vessel_stay,
      ),
      fda_roe: response?.fda.fda_roe,
      voyage: response?.voyage,
      fda_currency_from: response?.fda.fda_currency_from,
      fda_currency_to: response?.fda.fda_currency_to,
      currency_conversion: response?.fda?.portagent_fda_amount,
      fda_amount: response?.fda.fda_amount,
      conversion_rate: response?.fda.conversion_rate,
      balance_due: response?.fda.balance_due,
      credit_note: response?.fda.credit_note ?? null,
      invoice_ref_no: response?.fda.invoice_ref_no,
      pda_remittance: this.pdaRemittance?.toFixed(2),
      converted_curr_from:
        response?.fda.converted_curr_from || response?.fda.fda_currency_from,
      converted_curr_to:
        response?.fda.converted_curr_to || response?.fda.fda_currency_to,
      conversion_fda_rate: response?.fda.conversion_fda_rate || 1,
      pmt_curr_from:
        response?.fda.pmt_curr_from || response?.fda.fda_currency_from,
      pmt_curr_to: response?.fda.pmt_curr_to || response?.fda.fda_currency_to,
    });
    this.copyOfMasterData = { ...this.portAgentForm.getRawValue() };
    this.ConvertedFromCurrencyList = [this.fromCurrency, this.toCurrency];
    this.PaymentFromCurrencyList = [this.fromCurrency, this.toCurrency];
    this.responseCurrencyConversion = response?.fda?.portagent_fda_amount;

    // Use updated tariff rules from response if available
    if (response?.port_tariff_rule) {
      this.tariffRules = response.port_tariff_rule;
      this.portServiceList = response.port_tariff_rule;
    }

    if (response?.fda?.converted_curr_to) {
      this.displayConvertedToCurrency =
        response?.fda?.converted_curr_to !== response?.fda?.fda_currency_to &&
        response?.fda?.converted_curr_to !== response?.fda?.fda_currency_from;
    } else {
      this.displayConvertedToCurrency = false;
    }
    this.convertedToCurrencyValue = response?.fda.converted_curr_to;
    this.recalculateTotals();
  }

  private handleAdditionalFields(response: any): void {
    let additionalProperties =
      response?.fda?.fda_vessel_details?.additional_property || [];
    // Override additionalProperties when refreshing - add ALL fields from rules without conditions
    if (this.isRefreshingRules) {
      additionalProperties = (this.additionalFieldsFromRules || []).map(
        (rule: any) => ({
          field_name: rule?.field_name,
          is_mandatory: rule?.is_mandatory,
          value: null, // Set to null for refresh to ensure clean state
        }),
      );
    }
    // Get current field names from additionalProperties (trimmed)
    const currentFieldNames = additionalProperties
      .map((item: any) => item?.field_name?.trim())
      .filter(Boolean);
    const fieldsToRemove = this.addedFields.filter((field) => {
      const exists = currentFieldNames.includes(field.fieldName?.trim());
      return !exists;
    });
    // Add missing fields into this.fields
    additionalProperties.forEach((item: any) => {
      const fieldName = item?.field_name?.trim();
      if (!fieldName) return;

      const existsInFields = this.fields.some(
        (f: any) => f.value?.trim() === fieldName,
      );

      if (!existsInFields) {
        this.fields.push({
          name: fieldName, // Add this for display
          label: fieldName,
          value: fieldName,
          type: 'input', // Add default type
        });

        // Add form control for the new field
        const isMandatory = item?.is_mandatory === 'Y';
        const value = item?.value ?? null;
        if (!this.portAgentForm.contains(fieldName)) {
          this.portAgentForm.addControl(
            fieldName,
            this.fb.control(value, isMandatory ? Validators.required : []),
          );
        }
      }
    });
    fieldsToRemove.forEach((field) => {
      if (this.portAgentForm.contains(field.controlName)) {
        this.portAgentForm.removeControl(field.controlName);
      }
      // Remove from fields array
      const fieldIndex = this.fields.findIndex(
        (f) => f.value === field.controlName,
      );
      if (fieldIndex > -1) {
        this.fields.splice(fieldIndex, 1);
      }
    });

    // Update addedFields to only include current fields
    this.addedFields = additionalProperties?.map((item: any) => ({
      fieldName: item?.field_name,
      controlName: item?.field_name,
      is_mandatory: item?.is_mandatory,
    }));

    // Add/update current fields
    this.addedFields?.forEach((field: any) => {
      const matchingProp = additionalProperties?.find((prop: any) => {
        return prop?.field_name === field.fieldName;
      });
      const isMandatory = field.is_mandatory === 'Y';
      const value = matchingProp?.value ?? null;

      if (!this.portAgentForm.contains(field.controlName)) {
        this.portAgentForm.addControl(
          field.controlName,
          this.fb.control(value, isMandatory ? Validators.required : []),
        );
      } else {
        this.portAgentForm.get(field.controlName)?.patchValue(value);
      }
    });
  }

  currencyConversion(rate: number, total: number) {
    const result = rate * total;
    return result.toFixed(2);
  }

  convertMinutesToDaysHoursShort(minutes: number): string {
    if (!minutes || minutes <= 0) {
      return '0D';
    }

    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);

    return `${days}D `;
  }

  mergeSystemValueFromMerakiJson(
    merakiItems: PA_Rules,
    portAgentItems: PA_Rules,
    pdaApprovedValue: PA_Rules,
  ) {
    if (this.isRefreshingRules) {
      return this.mergeAllMerakiServicesWithPortAgent(
        merakiItems,
        portAgentItems,
        pdaApprovedValue,
      );
    }

    return portAgentItems?.items.map((portAgent) => {
      const matchedMerakiService = merakiItems?.items.find((meraki) => {
        const serviceMatch = meraki?.service === portAgent.service;
        const purposeMatch =
          (meraki?.purpose || '') === (portAgent.purpose || '');
        return serviceMatch && purposeMatch;
      });
      const systemTotal = matchedMerakiService
        ? matchedMerakiService.total || 0
        : 0;
      // Find matching service in PDA approved value
      const matchedPdaService = pdaApprovedValue?.items.find(
        (pda) => pda?.service === portAgent.service,
      );
      const pdaTotal = matchedPdaService ? matchedPdaService.total || 0 : 0;
      let pdaApprovedTotalValue: any = pdaTotal;

      const mergedSubServices = [
        ...(matchedMerakiService && matchedMerakiService.subService
          ? matchedMerakiService.subService
          : []
        ).map((sub) => {
          // Find matching PDA service from PDA approved values
          const matchedPdaService = pdaApprovedValue?.items.find(
            (pda) => pda?.service === portAgent.service,
          );
          pdaApprovedTotalValue = matchedPdaService?.total || 0;
          // Find matching subservice in PDA for each subservice
          const matchedPdaSubService = this.withPda
            ? pdaApprovedValue?.items
                .flatMap((item) => item.subService || [])
                .find((pdaSub) => pdaSub.name === sub.name)
            : null;
          return {
            ...sub,
            optional: sub.optional ?? matchedPdaSubService?.optional,
            systemSubTotal: sub ? sub.sub_total || 0 : 0,
            systemFormulaInputs: sub ? sub.formula_inputs || [] : [],
            systemMovement: sub ? sub.movement : 0,
            pdaApprovedSubTotalValue: matchedPdaSubService?.sub_total || 0,
          };
        }),
      ];

      return {
        ...portAgent,
        systemTotal,
        pdaTotal,
        subService: mergedSubServices,
        pdaApprovedTotalValue: pdaApprovedTotalValue,
        info_msg: matchedMerakiService?.info_msg || portAgent.info_msg || '',
      };
    });
  }

  mergeAllMerakiServicesWithPortAgent(
    merakiItems: PA_Rules,
    portAgentItems: PA_Rules,
    pdaApprovedValue: PA_Rules,
  ) {
    const mergedServices =
      merakiItems?.items?.map((meraki) => {
        const matchedPortAgentService = portAgentItems?.items?.find(
          (portAgent) => {
            const serviceMatch = meraki?.service === portAgent.service;
            const purposeMatch =
              (meraki?.purpose || '') === (portAgent.purpose || '');
            return serviceMatch && purposeMatch;
          },
        );

        // Find matching service in PDA approved value
        const matchedPdaService = pdaApprovedValue?.items?.find(
          (pda) => pda?.service === meraki.service,
        );
        const pdaTotal = matchedPdaService ? matchedPdaService.total || 0 : 0;

        const mergedSubServices = (meraki?.subService || []).map((sub) => {
          // Find matching subservice in PDA for each subservice
          const matchedPdaSubService = this.withPda
            ? pdaApprovedValue?.items
                .flatMap((item) => item.subService || [])
                .find((pdaSub) => pdaSub.name === sub.name)
            : null;
          return {
            ...sub,
            optional: sub.optional ?? matchedPdaSubService?.optional,
            systemSubTotal: sub?.sub_total || 0,
            systemFormulaInputs: sub?.formula_inputs || [],
            systemMovement: sub?.movement || '',
            pdaApprovedSubTotalValue: matchedPdaSubService?.sub_total || 0,
          };
        });

        return {
          ...meraki,
          systemTotal: meraki.total || 0,
          total: matchedPortAgentService?.total || 0,
          pa_remark: matchedPortAgentService?.pa_remark || '',
          meraki_feedback: matchedPortAgentService?.meraki_feedback || '',
          meraki_remark_client:
            matchedPortAgentService?.meraki_remark_client || '',
          client_comment: matchedPortAgentService?.client_comment || '',
          client_option: matchedPortAgentService?.client_option || '',
          negotiate: matchedPortAgentService?.negotiate || 'N',
          agreed: matchedPortAgentService?.agreed || 'Y',
          display_to_client: matchedPortAgentService?.display_to_client || 'N',
          pdaTotal,
          pdaApprovedTotalValue: pdaTotal,
          subService: mergedSubServices,
          info_msg: meraki?.info_msg || '',
        };
      }) || [];

    // Add PDA services that are not present in tariff rules (only if withPda is true)
    if (this.withPda && pdaApprovedValue?.items) {
      const pdaOnlyServices = pdaApprovedValue.items.filter((pdaService) => {
        // Check if this PDA service exists in the merged services (from Meraki/tariff rules)
        return !mergedServices.some(
          (mergedService) => mergedService.service === pdaService.service,
        );
      });

      // Add PDA-only services to the merged list
      pdaOnlyServices.forEach((pdaService) => {
        const mergedSubServices = (pdaService?.subService || []).map((sub) => ({
          ...sub,
          systemSubTotal: 0, // No system value for PDA-only services
          systemFormulaInputs: [],
          systemMovement: '',
          pdaApprovedSubTotalValue: sub?.sub_total || 0,
        }));
        mergedServices.push({
          ...pdaService,
          systemTotal: 0, // No system value for PDA-only services
          total: 0, // No agent value initially
          pa_remark: '',
          meraki_feedback: '',
          meraki_remark_client: '',
          client_comment: '',
          client_option: '',
          negotiate: 'N',
          agreed: 'Y',
          display_to_client: 'N',
          pdaTotal: pdaService.total || 0,
          pdaApprovedTotalValue: pdaService.total || 0,
          subService: mergedSubServices,
          info_msg: '',
        });
      });
    }

    return mergedServices;
  }

  onSelect(fieldName: string, event: any) {
    if (fieldName === 'Country') {
      if (event.value === this.previousCountryId) {
        return;
      }

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: {
          header: 'Country Change Warning',
          text: 'Changing the country will reset the services. Do you want to continue?',
        },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.previousCountryId = event.value;
          this.isPortChanged = true; // Country change also requires recalculation
          const currency = getCurrencyFromCountry(
            this.countryList,
            event.value,
          );
          this.portAgentForm.patchValue({
            fda_currency_from: currency,
          });
          this.loader.show();
          this.portService.getPortsByCountryId(event.value).subscribe({
            next: (ports) => {
              this.portList = ports;
              this.fields.forEach((field) => {
                if (field.name === 'Port') {
                  field.options = this.portList.map((port: any) => ({
                    port_id: port.port_id,
                    name: port.name,
                  }));
                }
              });
              this.filteredOptions['port_id'] = this.portList.map(
                (port: any) => ({
                  port_id: port.port_id,
                  name: port.name,
                }),
              );
              this.loader.hide();
            },
            error: (err: any) => {
              this.portList = [];
              this.filteredOptions['port_id'] = [];
              this.fields.forEach((field) => {
                if (field.name === 'Port') {
                  field.options = this.portList.map((port: any) => ({
                    port_id: port.port_id,
                    name: port.name,
                  }));
                }
              });
              this.loader.hide();

              this.errMsg =
                err?.error?.error ||
                'Something went wrong please try again later.';

              this.snackBar.error(this.errMsg);
            },
          });

          this.addedFields = [];
          this.portAgentForm.patchValue({
            port_id: null,
            purpose_id: null,
            converted_curr_from: null,
            pmt_curr_from: null,
          });

          this.serviceList = new PA_Rules();
          this.merakiServiceList = new PA_Rules();
          this.agentServiceGrandTotal = 0;
          this.merakiServiceGrandTotal = 0;
          this.datasource.data = [];
          this.previousPurposeId = null;
          this.previousPortId = null;
          removeAddedFieldsAndControls(
            this.portAgentForm,
            this.addedFields,
            this.fields,
          );
        } else {
          this.portAgentForm
            .get('country_id')
            ?.setValue(this.previousCountryId, { emitEvent: false });
          this.portAgentForm
            .get('port_id')
            ?.setValue(this.previousPortId, { emitEvent: false });
          this.portAgentForm
            .get('purpose_id')
            ?.setValue(this.previousPurposeId, { emitEvent: false });
          const purposeId = this.portAgentForm.get('purpose_id')?.value;
          const purpose = getPurposeName(this.purposeList, purposeId);
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
          }
          this.populateServicesFromList();
        }
      });
    } else if (fieldName === 'Vessel') {
      const control = this.portAgentForm.get('vessel_id');
      const value = control?.value;
      const selectedVessel = this.vesselList.filter(
        (vessel) => vessel.vessel_id === value,
      );
      if (selectedVessel.length > 0) {
        const vessel = selectedVessel[0];
        this.portAgentForm.patchValue({
          imo_number: vessel.imo_number,
          nrt: vessel.nrt,
          grt: vessel.grt,
          rgrt: vessel.rgrt,
          depth: vessel.depth,
          loa: vessel.loa,
          beam: vessel.beam,
          type: vessel.type,
          dwt: vessel.dwt,
          vessel_id: vessel.vessel_id,
          vessel: vessel.name,
        });
        control?.setErrors(null);
      }
    } else if (fieldName === 'Client') {
      this.loader.show();
      const vslpayload = {
        company_id: this.portAgentForm.get('client_id')?.value,
        fields: ['assigned_unassigned'],
      };
      this.clientService.VslListFromDb(vslpayload).subscribe({
        next: (response: any) => {
          this.vesselList = response.assigned_vessels || [];
          this.formatFieldData(this.modFields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.vesselList = [];
          this.errMsg = error?.error?.error || 'Failed to fetch vessel details';
          this.snackBar.error(this.errMsg);
          this.loader.hide();
        },
      });
    } else if (fieldName === 'Port') {
      const port_id = event.value;
      if (!this.previousPortId) {
        this.previousPortId = port_id;
        this.tariffrulesByPort(port_id);
        this.addedFields = addAdditionalFieldsToFieldsArray(
          port_id,
          this.portList,
          this.fields,
          this.portAgentForm,
          this.addedFields,
          this.filteredOptions,
          this.fb,
        );

        if (this.portIdValue === port_id) {
          this.portChange = 'N';
        } else {
          this.portChange = 'Y';
        }
        return;
      }
      // If same port selected, do nothing
      if (port_id === this.previousPortId) {
        return;
      }

      // Different port selected, show warning
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: {
          header: 'Port Change Warning',
          text: 'Changing the port will reset the services. Do you want to continue?',
        },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.previousPortId = port_id;
          this.isPortChanged = true; // Port has been changed
          this.addedFields = [];
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );
          this.tariffrulesByPort(port_id);
          if (this.portIdValue === port_id) {
            this.portChange = 'N';
          } else {
            this.portChange = 'Y';
          }

          this.portAgentForm.get('purpose_id')?.setValue(null);
          this.serviceList = new PA_Rules();
          this.merakiServiceList = new PA_Rules();
          this.agentServiceGrandTotal = 0;
          this.merakiServiceGrandTotal = 0;
          this.datasource.data = [];
          this.previousPurposeId = null;
          removeAddedFieldsAndControls(
            this.portAgentForm,
            this.addedFields,
            this.fields,
          );
        } else {
          this.portAgentForm.patchValue(
            {
              port_id: this.previousPortId,
            },
            { emitEvent: false },
          );
          this.portAgentForm
            .get('purpose_id')
            ?.setValue(this.previousPurposeId, { emitEvent: false });
          const purposeId = this.portAgentForm.get('purpose_id')?.value;
          const purpose = getPurposeName(this.purposeList, purposeId);
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
          }
          this.populateServicesFromList();
        }
      });
    } else if (fieldName === 'Purpose') {
      this.isPurposeChanged = true;
      const purposeId = event.value;
      const portId = this.portAgentForm.get('port_id')?.value;
      if (!this.previousPurposeId && portId) {
        // Port was changed, now purpose is being selected - don't show services
        this.previousPurposeId = purposeId;
        return;
      }

      if (this.previousPurposeId && purposeId !== this.previousPurposeId) {
        // Purpose is changing, show warning dialog
        this.previousServiceData = {
          serviceList: JSON.parse(JSON.stringify(this.serviceList)),
          mergedServiceList: JSON.parse(JSON.stringify(this.mergedServiceList)),
          serviceFormArray: this.serviceListFormArray.getRawValue(),
          agentServiceGrandTotal: this.agentServiceGrandTotal,
        };
        this.showDataLostWarning(purposeId);
      } else {
        // First time selecting purpose or same purpose selected
        this.previousPurposeId = purposeId;

        // If port was just changed, call recalculateData to get fresh services
        if (portId && this.isPortChanged) {
          this.tariffrulesByPort(portId);
          this.isPortChanged = false; // Reset after triggering recalculation
        } else {
          // Normal flow - just filter and display services
          const purpose = getPurposeName(this.purposeList, purposeId);
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
            if (this.serviceList.items.length > 0) {
              this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
                this.merakiServiceList,
                this.serviceList,
                this.PDAapprovedValue,
              );
              this.populateServicesFromList();
            } else {
              this.snackBar.error(
                'No Services found for the selected purpose',
              );
              this.datasource.data = [];
            }
          }
        }
      }
    } else if (fieldName === 'Converted Currency To') {
      const value = event.value;
      this.displayConvertedToCurrency =
        this.fromCurrency !== value && this.toCurrency !== value;
      this.convertedToCurrencyValue = value;
      this.PaymentFromCurrencyList = [];
      this.PaymentFromCurrencyList = [this.fromCurrency, this.toCurrency];
      if (!this.PaymentFromCurrencyList.includes(value)) {
        this.PaymentFromCurrencyList.push(value);
      }
    } else if (fieldName === 'Payment Currency From') {
      this.recalculateTotals();
    }
  }
  showDataLostWarning(newPurposeId: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Data Loss Warning',
        text: 'Are you sure you want to change the purpose? This will reset the services.',
      },
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        this.previousPurposeId = newPurposeId;
        const port_id = this.portAgentForm.get('port_id')?.value;
        this.isPurposeChanged = true;
        this.tariffrulesByPort(port_id);
        this.serviceList = new PA_Rules();
        this.mergedServiceList = [];
        this.serviceListFormArray.clear();
        this.datasource.data = [];
        this.agentServiceGrandTotal = 0;
        this.merakiServiceGrandTotal = 0;
        this.portAgentForm.patchValue({
          conversion_rate: null,
          currency_conversion: null,
          fda_amount: null,
          balance_due: null,
        });
        this.agentServiceGrandTotal = 0;

        // Load services for the newly selected purpose
        const purpose = getPurposeName(this.purposeList, newPurposeId);
        if (purpose) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
          if (this.serviceList.items.length > 0) {
            this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
              this.merakiServiceList,
              this.serviceList,
              this.PDAapprovedValue,
            );
            this.populateServicesFromList();
          }
        }
      } else {
        // Restore previous purpose and associated data
        this.isPurposeInternalChange = true;
        this.portAgentForm
          .get('purpose_id')
          ?.setValue(this.previousPurposeId, { emitEvent: false });

        // Restore previous service data
        if (this.previousServiceData) {
          this.serviceList = this.previousServiceData.serviceList;
          this.mergedServiceList = this.previousServiceData.mergedServiceList;
          this.agentServiceGrandTotal =
            this.previousServiceData.agentServiceGrandTotal;

          // Restore form array with proper FormGroup structure
          this.serviceListFormArray.clear();
          this.previousServiceData.serviceFormArray.forEach(
            (serviceData: any) => {
              const subServiceArray = this.fb.array(
                (serviceData.subService || []).map((sub: any) =>
                  this.fb.group({
                    SNO: [serviceData.SNO],
                    name: [sub.name],
                    purpose: [sub.purpose],
                    basic_value: [sub.basic_value],
                    calculated_basic_value: [sub.calculated_basic_value],
                    hide: [sub.hide],
                    unique_key: [sub.unique_key],
                    movement: [sub.movement],
                    tariff_percent: [sub.tariff_percent],
                    formula_result: [sub.formula_result],
                    optional: [sub.optional === 'Y' || sub.optional === true],
                    operational_flag: [sub.operational_flag],
                    sub_total: [sub.sub_total],
                    formula_inputs: [sub.formula_inputs],
                    isSubService: [true],
                    systemMovement: [sub.systemMovement],
                    systemSubTotal: [sub.systemSubTotal],
                    systemFormulaInputs: [sub.systemFormulaInputs],
                    pdaApprovedSubTotalValue: [sub.pdaApprovedSubTotalValue],
                    formattedSystemMovement: [sub.formattedSystemMovement],
                  }),
                ),
              );

              const serviceGroup = this.fb.group({
                SNO: [serviceData.SNO],
                code: [serviceData.code],
                total: [serviceData.total],
                service: [serviceData.service],
                purpose: [serviceData.purpose],
                pa_remark: [serviceData.pa_remark],
                meraki_feedback: [serviceData.meraki_feedback],
                meraki_remark_client: [serviceData.meraki_remark_client],
                client_comment: [serviceData.client_comment],
                client_option: [serviceData.client_option],
                info_msg: [serviceData.info_msg],
                negotiate: [serviceData.negotiate],
                agreed: [serviceData.agreed],
                display_to_client: [serviceData.display_to_client],
                subService: subServiceArray,
                isSubService: [false],
                expanded: [serviceData.expanded],
                agreedOrNegotiate: [serviceData.agreedOrNegotiate],
                systemTotal: [serviceData.systemTotal],
                pdaApprovedTotalValue: [serviceData.pdaApprovedTotalValue],
                serviceIndex: [serviceData.serviceIndex],
                formated_client_comment: [serviceData.formated_client_comment],
              });
              this.serviceListFormArray.push(serviceGroup);
            },
          );

          this.updateDatasource();
        }

        this.isPurposeInternalChange = false;
      }
    });
  }

  transformJsonData(formData: any): any {
    const merakiPdaData = this.fdaEditData.fda.meraki_pda_data;
    const portAgentFdaData = this.fdaEditData.fda.portagent_fda_data;
    return {
      disbursement_seq: this.fdaEditData.disbursement_seq,
      disbursement_id: this.fdaEditData.disbursement_id,
      port_tariff_rule:
        this.isPurposeChanged && this.isPortChanged
          ? this.tariffRules
          : this.tariffRules?.items?.length > 0
            ? this.UpdateModifiedMovementToTariifRules()
            : null,
      client_id: formData.client_id,
      portChange: this.portChange,
      portagent_id: formData.portagent_id,
      country_id: this.fdaEditData.country_id,
      port_id: this.fdaEditData.port_id,
      pda_vsl_id: this.fdaEditData.vsl_id,
      cargo_id: formData.cargo_id,
      voyage: formData.voyage,
      roe: formData.fda_roe,
      eta: formData.eta ? formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? formatToLocalISOString(formData.etd) : null,
      fda_currency_from: formData.fda_currency_from,
      fda_currency_to: formData.fda_currency_to,
      credit_note: formData.credit_note,
      grand_total: formData.fda_amount,
      conversion_rate: formData.conversion_rate,
      currency_conversion: formData.currency_conversion,
      balance_due: formData.balance_due,
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      vessel: {
        vsl_id: formData.vessel_id,
        imo_number: formData.imo_number,
        name: formData.vessel,
        grt: formData.grt,
        rgrt: formData.rgrt,
        type: formData.type,
        nrt: formData.nrt,
        loa: formData.loa,
        beam: formData.beam,
        depth: formData.depth,
        dwt: formData.dwt,
        additional_properties: this.getAdditionalPropertiesFromForm(),
      },
      vessel_stay: convertVesselStayToMinutes(formData.vessel_stay),
      fda_custom_calculation: this.fdaEditData?.fda?.fda_custom_calculation
        ? 'Y'
        : 'N',
      meraki_pda_data: {
        disbursement_seq: merakiPdaData?.disbursement_seq || null,
        voyage: merakiPdaData?.voyage || null,
        eta: merakiPdaData?.eta || null,
        etd: merakiPdaData?.etd || null,
        fda_roe: merakiPdaData?.fda_roe || null,
        vessel_stay: merakiPdaData?.vessel_stay || null,
        client: {
          client_id: merakiPdaData?.client.client_id || null,
          name: merakiPdaData?.client.name || '',
          address: merakiPdaData?.client.address || '',
        },
        port_agent: {
          name: merakiPdaData?.port_agent?.name || '',
          address: merakiPdaData?.port_agent.address || '',
          bank_details: {
            country_name:
              merakiPdaData?.port_agent.bank_details.company_name || '',
            beneficiary_acc_holder_name:
              merakiPdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name || '',
            bank_name: merakiPdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              merakiPdaData?.port_agent.bank_details
                .correspondent_account_number || '',
            current_account_number:
              merakiPdaData?.port_agent.bank_details.current_account_number ||
              '',
            ifsc_code: merakiPdaData?.port_agent.bank_details.ifsc_code || '',
            bik_code: merakiPdaData?.port_agent.bank_details.bik_code || '',
            swift_code: merakiPdaData?.port_agent.bank_details.swift_code || '',
            currency: merakiPdaData?.port_agent.bank_details.currency || '',
            inn_code: merakiPdaData?.port_agent.bank_details.inn_code || '',
            iban_number:
              merakiPdaData?.port_agent.bank_details.iban_number || '',
            bic_code: merakiPdaData?.port_agent.bank_details.bic_code || '',
            branch_address:
              merakiPdaData?.port_agent.bank_details.branch_address || '',
          },
        },
        port: {
          port_id: merakiPdaData?.port.potr_id || null,
          name: merakiPdaData?.port.name || '',
        },
        country: {
          country_id: merakiPdaData?.country.country_id || '',
          name: merakiPdaData?.country.name || '',
        },
        purpose: {
          purpose_id: merakiPdaData?.purpose.purpose_id || '',
          name: merakiPdaData?.purpose.name || '',
        },
        cargo: {
          cargo_id: merakiPdaData?.cargo.cargo_id || '',
          type: merakiPdaData?.cargo.type || '',
        },
        services: this.transFormServiceData(
          this.merakiServiceList,
          'merakiData',
        ),
      },
      portagent_fda_data: {
        disbursement_seq: portAgentFdaData?.disbursement_seq,
        voyage: formData.voyage,
        eta: formData.eta,
        etd: formData.etd,
        fda_roe: formData.fda_roe,
        vessel_stay: formData.vessel_stay,
        client: {
          client_id: formData.client_id,
          name:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.company_name || '',
          address:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.address || '',
        },
        port_agent: {
          name: portAgentFdaData?.port_agent.name,
          address: portAgentFdaData?.port_agent.address,
          bank_details: {
            country_name:
              portAgentFdaData?.port_agent.bank_details.company_name,
            beneficiary_acc_holder_name:
              portAgentFdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name,
            bank_name: portAgentFdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              portAgentFdaData?.port_agent.bank_details
                .correspondent_account_number,
            current_account_number:
              portAgentFdaData?.port_agent.bank_details.current_account_number,
            ifsc_code: portAgentFdaData?.port_agent.bank_details.ifsc_code,
            bik_code: portAgentFdaData?.port_agent.bank_details.bik_code,
            swift_code: portAgentFdaData?.port_agent.bank_details.swift_code,
            currency: portAgentFdaData?.port_agent.bank_details.currency,
            inn_code: portAgentFdaData?.port_agent.bank_details.inn_code,
            iban_number: portAgentFdaData?.port_agent.bank_details.iban_number,
            bic_code: portAgentFdaData?.port_agent.bank_details.bic_code,
            branch_address:
              portAgentFdaData?.port_agent.bank_details.branch_address,
          },
        },
        port: {
          port_id: this.fdaEditData.port_id,
          name:
            this.portList.find((port: any) => port.port_id === formData.port_id)
              ?.name || '',
        },
        country: {
          country_id: formData.country_id,
          name:
            this.countryList.find(
              (country: any) => country.country_id === formData.country_id,
            )?.name || '',
        },
        purpose: {
          purpose_id: formData.purpose_id,
          name:
            this.purposeList.find(
              (purpose: any) => purpose.purpose_id === formData.purpose_id,
            )?.name || '',
        },
        cargo: {
          cargo_id: formData.cargo_id,
          type:
            this.cargoList.find(
              (cargo: any) => cargo.cargo_id === formData.cargo_id,
            )?.type || '',
        },
        fda_custom_calculation: this.fdaEditData?.fda?.fda_custom_calculation
          ? 'Y'
          : 'N',
        conversion_rate: formData.conversion_rate || null,
        currency_conversion: formData.currency_conversion || null,
        vessel: {
          vsl_id: formData.vessel_id,
          imo_number: formData.imo_number,
          name: formData.vessel,
          grt: formData.grt,
          rgrt: formData.rgrt,
          nrt: formData.nrt,
          loa: formData.loa,
          beam: formData.beam,
          depth: formData.depth,
          dwt: formData.dwt,
          type: formData.type,
          additional_properties: this.getAdditionalPropertiesFromForm(),
          additional_properties_object: getAdditionalPropertiesObjectFromForm(
            this.addedFields,
            this.portAgentForm,
            this.fields,
          ),
        },
        services: this.isPurposeChanged
          ? this.serviceList
          : this.transFormServiceData(this.serviceList, 'agentData'),
      },
      email_to: this.fdaEditData.fda.email_to || null,
      email_cc: this.fdaEditData.fda.email_cc || null,
      file_list:
        this.fileList
          .filter((file: any) => file.sync === 'N')
          .map((file: any) => file.file_id) || [],
      converted_curr_from: formData.converted_curr_from || null,
      converted_curr_to: formData.converted_curr_to || null,
      conversion_fda_rate: formData.conversion_fda_rate || null,
      pmt_curr_from: formData.pmt_curr_from || null,
      pmt_curr_to: formData.pmt_curr_to || null,
      is_rules_refreshed: this.rulesWereRefreshed ? 'Y' : 'N',
    };
  }

  transformJsonDataToFdaSave(formData: any): any {
    const merakiPdaData = this.fdaEditData?.fda?.meraki_pda_data;
    const portAgentFdaData = this.fdaEditData.fda.portagent_fda_data;
    return {
      disbursement_seq: this.fdaEditData.disbursement_seq,
      disbursement_id: this.fdaEditData.disbursement_id,
      port_tariff_rule:
        this.isPurposeChanged && this.isPortChanged
          ? this.tariffRules
          : this.tariffRules?.items?.length > 0
            ? this.UpdateModifiedMovementToTariifRules()
            : null,
      cargo_id: formData?.cargo_id || '',
      purpose_id: formData?.purpose_id || '',
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: this.fdaEditData.country_id,
      port_id: this.fdaEditData.port_id,
      pda_vsl_id: this.fdaEditData.vsl_id,
      voyage: formData.voyage,
      roe: formData.fda_roe,
      eta: formData.eta ? formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? formatToLocalISOString(formData.etd) : null,
      fda_currency_from: formData.fda_currency_from,
      fda_currency_to: formData.fda_currency_to,
      credit_note: formData.credit_note,
      fda_amount: formData.fda_amount,
      conversion_rate: formData.conversion_rate,
      currency_conversion: formData.currency_conversion,
      balance_due: formData.balance_due,
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      meraki_pda_amount: this.getMerakiPdaAmount() || 0,
      // portagent_fda_amount: this.getConvertedSystemAndAgentTotal('agent') || 0,
      portagent_fda_amount:
        formData.currency_conversion != null
          ? Number(formData.currency_conversion).toFixed(2)
          : null,
      vessel: {
        vsl_id: String(formData.vessel_id),
        imo_number: formData.imo_number,
        name: formData.vessel,
        grt: String(formData.grt),
        rgrt: String(formData.rgrt),
        nrt: String(formData.nrt),
        loa: String(formData.loa),
        beam: String(formData.beam),
        depth: String(formData.depth),
        dwt: String(formData.dwt),
        type: formData.type,
        additional_properties: this.getAdditionalPropertiesFromForm(),
      },
      vessel_stay: convertVesselStayToMinutes(formData.vessel_stay),
      fda_custom_calculation: this.fdaEditData?.fda?.fda_custom_calculation
        ? 'Y'
        : 'N',
      meraki_pda_data: {
        disbursement_seq: merakiPdaData?.disbursement_seq || null,
        voyage: merakiPdaData?.voyage || null,
        eta: merakiPdaData?.eta || null,
        etd: merakiPdaData?.etd || null,
        fda_roe: merakiPdaData?.fda_roe || null,
        vessel_stay: merakiPdaData?.vessel_stay || null,
        client: {
          client_id: merakiPdaData?.client.client_id || null,
          name: merakiPdaData?.client.name || '',
          address: merakiPdaData?.client.address || '',
        },
        port_agent: {
          name: merakiPdaData?.port_agent.name || '',
          address: merakiPdaData?.port_agent.address || '',
          bank_details: {
            country_name:
              merakiPdaData?.port_agent.bank_details.company_name || '',
            beneficiary_acc_holder_name:
              merakiPdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name || '',
            bank_name: merakiPdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              merakiPdaData?.port_agent.bank_details
                .correspondent_account_number || '',
            current_account_number:
              merakiPdaData?.port_agent.bank_details.current_account_number ||
              '',
            ifsc_code: merakiPdaData?.port_agent.bank_details.ifsc_code || '',
            bik_code: merakiPdaData?.port_agent.bank_details.bik_code || '',
            swift_code: merakiPdaData?.port_agent.bank_details.swift_code || '',
            currency: merakiPdaData?.port_agent.bank_details.currency || '',
            inn_code: merakiPdaData?.port_agent.bank_details.inn_code || '',
            iban_number:
              merakiPdaData?.port_agent.bank_details.iban_number || '',
            bic_code: merakiPdaData?.port_agent.bank_details.bic_code || '',
            branch_address:
              merakiPdaData?.port_agent.bank_details.branch_address || '',
          },
        },
        port: {
          port_id: merakiPdaData?.port.potr_id || null,
          name: merakiPdaData?.port.name || '',
        },
        country: {
          country_id: merakiPdaData?.country.country_id || '',
          name: merakiPdaData?.country.name || '',
        },
        purpose: {
          purpose_id: merakiPdaData?.purpose.purpose_id || '',
          name: merakiPdaData?.purpose.name || '',
        },
        cargo: {
          cargo_id: merakiPdaData?.cargo.cargo_id || '',
          type: merakiPdaData?.cargo.type || '',
        },
        services: this.transFormServiceData(
          this.merakiServiceList,
          'merakiData',
        ),
      },
      portagent_fda_data: {
        disbursement_seq: portAgentFdaData?.disbursement_seq,
        voyage: formData.voyage,
        eta: formData.eta,
        etd: formData.etd,
        fda_roe: formData.fda_roe,
        vessel_stay: formData.vessel_stay,
        client: {
          client_id: formData.client_id,
          name:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.company_name || '',
          address:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.address || '',
        },
        port_agent: {
          name: portAgentFdaData?.port_agent.name,
          address: portAgentFdaData?.port_agent.address,
          bank_details: {
            country_name:
              portAgentFdaData?.port_agent.bank_details.company_name,
            beneficiary_acc_holder_name:
              portAgentFdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name,
            bank_name: portAgentFdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              portAgentFdaData?.port_agent.bank_details
                .correspondent_account_number,
            current_account_number:
              portAgentFdaData?.port_agent.bank_details.current_account_number,
            ifsc_code: portAgentFdaData?.port_agent.bank_details.ifsc_code,
            bik_code: portAgentFdaData?.port_agent.bank_details.bik_code,
            swift_code: portAgentFdaData?.port_agent.bank_details.swift_code,
            currency: portAgentFdaData?.port_agent.bank_details.currency,
            inn_code: portAgentFdaData?.port_agent.bank_details.inn_code,
            iban_number: portAgentFdaData?.port_agent.bank_details.iban_number,
            bic_code: portAgentFdaData?.port_agent.bank_details.bic_code,
            branch_address:
              portAgentFdaData?.port_agent.bank_details.branch_address,
          },
        },
        port: {
          port_id: this.fdaEditData.port_id,
          name:
            this.portList.find((port: any) => port.port_id === formData.port_id)
              ?.name || '',
        },
        country: {
          country_id: formData.country_id,
          name:
            this.countryList.find(
              (country: any) => country.country_id === formData.country_id,
            )?.name || '',
        },
        purpose: {
          purpose_id: formData.purpose_id,
          name:
            this.purposeList.find(
              (purpose: any) => purpose.purpose_id === formData.purpose_id,
            )?.name || '',
        },
        cargo: {
          cargo_id: formData.cargo_id,
          type:
            this.cargoList.find(
              (cargo: any) => cargo.cargo_id === formData.cargo_id,
            )?.type || '',
        },
        fda_custom_calculation: this.fdaEditData?.fda?.fda_custom_calculation
          ? 'Y'
          : 'N',
        conversion_rate: formData.conversion_rate || null,
        currency_conversion: formData.currency_conversion || null,
        vessel: {
          vsl_id: formData.vessel_id,
          imo_number: formData.imo_number,
          name: formData.vessel,
          grt: formData.grt,
          rgrt: formData.rgrt,
          nrt: formData.nrt,
          loa: formData.loa,
          beam: formData.beam,
          depth: formData.depth,
          dwt: formData.dwt,
          type: formData.type,
          additional_properties: this.getAdditionalPropertiesFromForm(),
          additional_properties_object: getAdditionalPropertiesObjectFromForm(
            this.addedFields,
            this.portAgentForm,
            this.fields,
          ),
        },
        services: this.transFormServiceData(this.serviceList, 'agentData'),
      },
      email_to: this.fdaEditData.fda.email_to || null,
      email_cc: this.fdaEditData.fda.email_cc || null,
      file_list:
        this.fileList
          .filter((file: any) => file.sync === 'N')
          .map((file: any) => file.file_id) || [],
      converted_curr_from: formData.converted_curr_from || null,
      converted_curr_to: formData.converted_curr_to || null,
      conversion_fda_rate: formData.conversion_fda_rate || null,
      pmt_curr_from: formData.pmt_curr_from || null,
      pmt_curr_to: formData.pmt_curr_to || null,
      is_rules_refreshed: this.rulesWereRefreshed ? 'Y' : 'N',
    };
  }

  transFormServiceData(formData: any, serviceData: string): PA_Rules {
    const itemsArray: PA_Item[] = this.serviceListFormArray.controls
      .map((ctrl: AbstractControl) => {
        const value = ctrl.getRawValue();
        
        // Skip map item if requirements aren't met
        if (value.code === null && serviceData === 'merakiData') {
          return null;
        }

        // Construct standard structure matching PA_Item specs
        const itemData: Partial<PA_Item> = {
          SNO: value.SNO ?? 0,
          code: value.code ?? null,
          total: serviceData === 'agentData' ? (value.total ?? null) : (value.systemTotal ?? null),
          service: value.service ?? null,
          purpose: value.purpose ?? null,
          pa_remark: serviceData === 'agentData' ? value.pa_remark : null,
          meraki_feedback: serviceData === 'agentData' ? value.meraki_feedback : null,
          meraki_remark_client: serviceData === 'agentData' ? value.meraki_remark_client : null,
          client_comment: serviceData === 'agentData' ? value.client_comment : null,
          client_option: serviceData === 'agentData' ? value.client_option : null,
          info_msg: serviceData === 'agentData' ? value.info_msg : null,
          negotiate: value.agreedOrNegotiate === 'Negotiate' && serviceData === 'agentData' ? 'Y' : 'N',
          agreed: value.agreedOrNegotiate === 'Agreed' && serviceData === 'agentData' ? 'Y' : 'N',
          display_to_client: serviceData === 'agentData' ? value.display_to_client : null,
          subService: (value.subService || []).map((sub: any) => new SubService({
            name: sub.name ?? null,
            purpose: sub.purpose ?? null,
            basic_value: sub.basic_value ?? null,
            calculated_basic_value: serviceData === 'merakiData' ? sub.calculated_basic_value : null,
            hide: sub.hide ?? 'N',
            unique_key: sub.unique_key ?? null,
            movement: serviceData === 'merakiData' ? (replaceMovementPart(sub.movement, 1, sub.formattedSystemMovement) || '1') : sub.movement,
            tariff_percent: sub.tariff_percent ?? 1,
            formula_result: sub.formula_result ?? 'Basic Value * movement * Tariff %',
            optional: sub.optional ? 'Y' : 'N',
            operational_flag: sub.operational_flag ?? '+',
            sub_total: serviceData === 'agentData' ? (sub.sub_total ?? 0) : (sub.systemSubTotal ?? 0),
            formula_inputs: sub.formula_inputs ?? null,
            reference: sub.reference ?? 'N',
          })),
        };

        return new PA_Item(itemData);
      })
      .filter((item): item is PA_Item => item !== null); // Standard Type Guard to eliminate null types

    return new PA_Rules({
      items: itemsArray,
      grand_total: serviceData === 'agentData'
        ? (this.agentServiceGrandTotal !== null ? Number(this.agentServiceGrandTotal.toFixed(2)) : null)
        : (this.merakiServiceGrandTotal !== null ? Number(this.merakiServiceGrandTotal.toFixed(2)) : null),
    });
  }

  // method to calculate the agentService total and grandTotal
  calculateAgentServiceGrandTotal() {
    this.agentServiceGrandTotal = this.serviceListFormArray.controls.reduce(
      (sum, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const totalValue = value.total != null ? Number(value.total) : 0;
        const total = sum + totalValue;
        return total;
      },
      0,
    );

    // Only recalculate totals if status is not completed
    if (this.fdaStatus !== 7) {
      this.recalculateTotals();
    }
  }

  // Method to handle agent value changes and update grand total dynamically
  onAgentValueChange(service: AbstractControl) {
    if (service) {
      this.checkAndUpdateToggleStatus(service);
    }
    this.calculateAgentServiceGrandTotal();
    this.getSystemAndAgentTotal('agent', 'ToCurrency');
    this.getSystemAndAgentTotal('agent', 'convertedToCurrency');

    this.calculateSystemAndAgentValueWithRoe(service, 'agent', 'ToCurrency');
    this.calculateSystemAndAgentValueWithRoe(
      service,
      'agent',
      'convertedToCurrency',
    );
  }

  // Method to automatically set toggle to negotiate if agent value is greater than other values
  checkAndUpdateToggleStatus(service: AbstractControl) {
    const agentValue = Number(service.get('total')?.value || 0);
    const systemValue = Number(service.get('systemTotal')?.value || 0);
    const pdaApprovedValue = Number(
      service.get('pdaApprovedTotalValue')?.value || 0,
    );

    // Check if agent value is greater than system value or PDA approved value
    let shouldNegotiate = false;

    if (this.withPda) {
      // If PDA exists, check against both system and PDA approved values
      shouldNegotiate =
        agentValue > systemValue || agentValue > pdaApprovedValue;
    } else {
      // If no PDA, only check against system value
      shouldNegotiate = agentValue > systemValue;
    }

    if (shouldNegotiate) {
      // Automatically set to negotiate if agent value is greater
      service.get('negotiate')?.setValue('Y');
      service.get('agreed')?.setValue('N');
      service.get('agreedOrNegotiate')?.setValue('Negotiate');
    } else {
      // Automatically set to agreed if agent value is equal or below other values
      service.get('negotiate')?.setValue('N');
      service.get('agreed')?.setValue('Y');
      service.get('agreedOrNegotiate')?.setValue('Agreed');
    }

    // Update the global negotiate status
    this.isNegotiateSelected = this.datasource.data.some(
      (serviceItem: FormGroup) => serviceItem.get('negotiate')?.value === 'Y',
    );

    this.updateDatasource();
  }

  // Method to update toggle status for all services (used after recalculation)
  updateAllToggleStatuses() {
    this.serviceListFormArray.controls.forEach((service: AbstractControl) => {
      const serviceGroup = service as FormGroup;
      const agentValue = Number(serviceGroup.get('total')?.value || 0);
      const systemValue = Number(serviceGroup.get('systemTotal')?.value || 0);
      const pdaApprovedValue = Number(
        serviceGroup.get('pdaApprovedTotalValue')?.value || 0,
      );

      // Check if agent value is greater than system value or PDA approved value
      let shouldNegotiate = false;

      if (this.withPda) {
        // If PDA exists, check against both system and PDA approved values
        shouldNegotiate =
          agentValue > systemValue || agentValue > pdaApprovedValue;
      } else {
        // If no PDA, only check against system value
        shouldNegotiate = agentValue > systemValue;
      }

      if (shouldNegotiate) {
        // Automatically set to negotiate if agent value is greater
        serviceGroup.get('negotiate')?.setValue('Y');
        serviceGroup.get('agreed')?.setValue('N');
        serviceGroup.get('agreedOrNegotiate')?.setValue('Negotiate');
      } else {
        // Automatically set to agreed if agent value is equal or below other values
        serviceGroup.get('negotiate')?.setValue('N');
        serviceGroup.get('agreed')?.setValue('Y');
        serviceGroup.get('agreedOrNegotiate')?.setValue('Agreed');
      }
    });

    // Update the global negotiate status
    this.isNegotiateSelected = this.serviceListFormArray.controls.some(
      (serviceItem: AbstractControl) =>
        (serviceItem as FormGroup).get('negotiate')?.value === 'Y',
    );

    this.updateDatasource();
  }

  recalculateTotals(): void {
    // If FDA is completed, don't recalculate - preserve response values
    if (this.fdaStatus === 7) {
      return;
    }

    const fdaRoe = Number(this.portAgentForm.get('fda_roe')?.value) || 1;
    const conversionRoe =
      Number(this.portAgentForm.get('conversion_fda_rate')?.value) || 1;
    const pmtCurrFrom = this.portAgentForm.get('pmt_curr_from')?.value;
    let grandTotal: number | null = null;
    if (this.fromCurrency === pmtCurrFrom) {
      grandTotal =
        this.agentServiceGrandTotal !== null
          ? Number(this.agentServiceGrandTotal)
          : null;
    } else if (this.toCurrency === pmtCurrFrom) {
      grandTotal =
        this.agentServiceGrandTotal !== null
          ? Number(this.agentServiceGrandTotal * fdaRoe)
          : null;
    } else if (
      this.convertedToCurrency === pmtCurrFrom &&
      this.convertedFromCurrency === this.toCurrency
    ) {
      grandTotal =
        this.agentServiceGrandTotal !== null
          ? Number(this.agentServiceGrandTotal * fdaRoe * conversionRoe)
          : null;
    } else if (this.convertedToCurrency === pmtCurrFrom) {
      grandTotal =
        this.agentServiceGrandTotal !== null
          ? Number(this.agentServiceGrandTotal * conversionRoe)
          : null;
    }

    const creditNote = Number(
      this.portAgentForm.get('credit_note')?.value || null,
    );
    const conversionRate = Number(
      this.portAgentForm.get('conversion_rate')?.value || null,
    );
    const pdaRemittance = Number(this.pdaRemittance || null);

    // Subtract credit note from grand total
    const adjustedTotal = grandTotal !== null ? grandTotal - creditNote : null;
    const currencyConversion =
      adjustedTotal !== null ? adjustedTotal * conversionRate : null;
    const balanceDue =
      currencyConversion !== null ? currencyConversion - pdaRemittance : null;
    this.portAgentForm.patchValue(
      {
        fda_amount: adjustedTotal !== null ? adjustedTotal.toFixed(2) : null,
        currency_conversion:
          currencyConversion !== null ? currencyConversion.toFixed(2) : null,
        balance_due: balanceDue !== null ? balanceDue.toFixed(2) : null,
      },
      { emitEvent: false },
    );
  }

  // method to calculate the meraki grand total
  calculateMerakiServicegrandTotal() {
    this.merakiServiceGrandTotal = this.serviceListFormArray.controls.reduce(
      (sum: number, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const totalValue =
          value.systemTotal != null ? Number(value.systemTotal) : null;
        return totalValue !== null ? sum + totalValue : sum;
      },
      0,
    );
    this.merakiServiceGrandTotal =
      this.merakiServiceGrandTotal !== null
        ? parseFloat(this.merakiServiceGrandTotal.toFixed(2))
        : null;
  }

  // method to push the additional properties to the addedFields from the portAgentForm
  getAdditionalPropertiesFromForm(): { [key: string]: any } {
    const additionalProps: { [key: string]: any } = {};
    const dateFields = this.modFields
      .filter((field) => field.type === 'date')
      .map((field) => field.name);
    this.addedFields.forEach(({ fieldName, controlName }) => {
      let value = this.portAgentForm.get(controlName)?.value ?? null;
      additionalProps[fieldName] = value;
      if (dateFields.includes(fieldName) && value) {
        additionalProps[fieldName] = formatToLocalISOString(value);
      }
    });

    return additionalProps;
  }

  // method to get the port tariff rule based on port id
  tariffrulesByPort(port_id: number) {
    this.serviceList = new PA_Rules();
    const requestBody = {
      page: 1,
      page_size: 1,
      query_name: '',
      port_id: port_id,
    };
    this.loader.show();
    this.portService.getTariffRules(requestBody).subscribe({
      next: (res) => {
        this.portServiceList = res?.data[0]?.rules;
        this.tariffRules = res?.data[0]?.rules;
        this.additionalFieldsFromRules = res?.data[0]?.vessel_fields || [];

        const purposeId = this.portAgentForm.get('purpose_id')?.value;
        const purpose = getPurposeName(this.purposeList, purposeId);

        if (this.isRefreshingRules) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
          const port_id = this.portAgentForm.get('port_id')?.value;
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );
          // Call recalculate API after fetching fresh rules
          this.recalculateData();
        } else {
          // Normal flow - filter by purpose
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
          if (this.isPurposeChanged) {
            this.recalculateData();
          }
        }

        this.loader.hide();
      },
      error: (err) => {
        this.isRefreshingRules = false; // Reset flag on error
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  // method to enable and disable the fileds based on requirement
  disableFields(withPda: boolean, portAgentReturnStatus: string | null) {
    if (!withPda) {
      this.portAgentForm.get('portagent_id')?.disable();
      this.portAgentForm.get('client_id')?.disable();
    } else if (withPda) {
      // if (portAgentReturnStatus === null || portAgentReturnStatus === "N") {
      //   this.portAgentForm.get('portagent_id')?.disable();
      // }
      // else if (portAgentReturnStatus === "Y") {
      //   this.portAgentForm.get('portagent_id')?.enable();
      // }
      this.portAgentForm.get('client_id')?.disable();
      this.portAgentForm.get('portagent_id')?.disable();
      this.portAgentForm.get('country_id')?.disable();
      this.portAgentForm.get('port_id')?.disable();
      this.portAgentForm.get('vessel_id')?.disable();
      this.portAgentForm.get('purpose_id')?.disable();
    }
  }

  onCheckboxClick(
    service: FormGroup,
    subServiceElement: any,
    subServiceIndex: number,
  ) {
    if (!service) return;

    const subServiceArray = service.get('subService') as FormArray;
    const subServiceControl = subServiceArray.at(subServiceIndex);
    if (!subServiceControl) return;

    // Toggle the 'optional' checkbox value
    const currentOptional = subServiceControl.get('optional')?.value;
    subServiceControl.get('optional')?.setValue(!currentOptional);

    let newSystemTotal = 0;

    // Recalculate the total by excluding the 'optional' items
    subServiceArray.controls.forEach((subCtrl) => {
      const isOptional = subCtrl.get('optional')?.value;

      let subTotal = 0;

      // Only include the total for non-optional services
      if (!isOptional) {
        subTotal = Number(subCtrl.get('systemSubTotal')?.value || 0);
        newSystemTotal += subTotal;
      }
    });

    // Ensure the total is non-negative
    newSystemTotal = Math.max(0, newSystemTotal);
    service.get('systemTotal')?.setValue(parseFloat(newSystemTotal.toFixed(2)));

    // Update grand total after the recalculation
    this.calculateMerakiServicegrandTotal();
  }

  // Method to recalculate system total based on subservice optional status
  recalculateSystemTotal(service: FormGroup) {
    const subServiceArray = service.get('subService') as FormArray;
    let newSystemTotal = 0;
    subServiceArray.controls.forEach((subCtrl) => {
      const isOptional = subCtrl.get('optional')?.value;
      const subTotal = Number(subCtrl.get('systemSubTotal')?.value || 0);

      if (!isOptional) {
        newSystemTotal += subTotal;
      }
    });
    newSystemTotal = Math.max(0, newSystemTotal);
    service.patchValue({ systemTotal: newSystemTotal.toFixed(2) });
  }

  // method to get the service for the selected subservice
  getService(subserviceElement: any): any {
    for (let service of this.serviceListFormArray.controls) {
      const subServices = service.get('subService')?.value || [];
      const subserviceFound = subServices.find(
        (sub: any) =>
          sub.SNO === subserviceElement.get('SNO')?.value &&
          sub.name === subserviceElement.get('name')?.value,
      );
      if (subserviceFound) {
        return service;
      }
      if (subServices.length === 0) {
        return service;
      }
    }
    return null;
  }

  // Method to handle the change in selection ('Negotiate' or 'Agreed')
  onSelectionChange(event: any): void {
    const services = this.serviceListFormArray.value;
    const isAnyServiceNegotiate = services.some(
      (service: any) => service.agreedOrNegotiate === 'Negotiate',
    );
    if (isAnyServiceNegotiate) {
      this.isNegotiateSelected = true;
    } else {
      this.isNegotiateSelected = false;
    }
  }

  updateAgreedOrNegotiate(element: FormGroup) {
    // Determine agent value vs system value
    const isSub = element.get('isSubService')?.value;
    const agentValue = isSub
      ? element.get('sub_total')?.value
      : element.get('total')?.value;
    const systemValue = isSub
      ? element.get('systemSubTotal')?.value
      : element.get('systemTotal')?.value;

    if (agentValue > systemValue) {
      element.get('agreedOrNegotiate')?.setValue('Negotiate'); // optional
    } else {
      element.get('agreedOrNegotiate')?.setValue('Agreed');
    }
  }

  onAgreedNegotiateToggle(serviceFormGroup: FormGroup, isNegotiate: boolean) {
    serviceFormGroup.get('negotiate')?.setValue(isNegotiate ? 'Y' : 'N');
    serviceFormGroup.get('agreed')?.setValue(isNegotiate ? 'N' : 'Y');
    serviceFormGroup
      .get('agreedOrNegotiate')
      ?.setValue(isNegotiate ? 'Negotiate' : 'Agreed');

    this.isNegotiateSelected = this.datasource.data.some(
      (service: FormGroup) => service.get('negotiate')?.value === 'Y',
    );
    this.updateDatasource();
  }

  // Method to get service note message based on value comparison
  getServiceNoteMessage(service: FormGroup): string {
    const agentValue = Number(service.get('total')?.value || 0);
    const systemValue = Number(service.get('systemTotal')?.value || 0);
    const pdaApprovedValue = Number(
      service.get('pdaApprovedTotalValue')?.value || 0,
    );
    const isNegotiate = service.get('negotiate')?.value === 'Y';

    // Check if agent value is greater than other values
    let isAgentValueHigher = false;
    if (this.withPda) {
      isAgentValueHigher =
        agentValue > systemValue || agentValue > pdaApprovedValue;
    } else {
      isAgentValueHigher = agentValue > systemValue;
    }

    if (!isAgentValueHigher) {
      return ''; // No message if agent value is not higher
    }

    // If agent value is higher, show message based on toggle state
    if (isNegotiate) {
      if (this.withPda) {
        if (agentValue > pdaApprovedValue && agentValue > systemValue) {
          return 'The agent value is greater than PDA approved value and system value.';
        } else if (agentValue > pdaApprovedValue) {
          return 'The agent value is greater than PDA approved value.';
        } else if (agentValue > systemValue) {
          return 'The agent value is greater than system value.';
        }
      } else {
        if (agentValue > systemValue) {
          return 'The agent value is greater than system value.';
        }
      }
    } else {
      return `You're agreed to the agent value.`;
    }

    return '';
  }

  // Method to get service note CSS class based on state
  getServiceNoteClass(service: FormGroup): string {
    const agentValue = Number(service.get('total')?.value || 0);
    const systemValue = Number(service.get('systemTotal')?.value || 0);
    const pdaApprovedValue = Number(
      service.get('pdaApprovedTotalValue')?.value || 0,
    );
    const isNegotiate = service.get('negotiate')?.value === 'Y';

    let isAgentValueHigher = false;
    if (this.withPda) {
      isAgentValueHigher =
        agentValue > systemValue || agentValue > pdaApprovedValue;
    } else {
      isAgentValueHigher = agentValue > systemValue;
    }

    if (!isAgentValueHigher) {
      return '';
    }

    return isNegotiate ? 'warning' : 'success';
  }

  // Method to check if service note should be displayed
  shouldShowServiceNote(service: FormGroup): boolean {
    return this.getServiceNoteMessage(service) !== '';
  }

  // Method to check if flag should be displayed
  shouldShowFlag(service: FormGroup): boolean {
    const agentValue = Number(service.get('total')?.value || 0);
    const systemValue = Number(service.get('systemTotal')?.value || 0);
    const pdaApprovedValue = Number(
      service.get('pdaApprovedTotalValue')?.value || 0,
    );
    const isAgreed = service.get('negotiate')?.value === 'N'; // 'N' means agreed

    // Check if agent value is greater than other values
    let isAgentValueHigher = false;
    if (this.withPda) {
      isAgentValueHigher =
        agentValue > systemValue || agentValue > pdaApprovedValue;
    } else {
      isAgentValueHigher = agentValue > systemValue;
    }

    // Previous Show flag only if agent value is higher AND user hasn't agreed to it
    // return isAgentValueHigher && !isAgreed;

    return isAgentValueHigher;
  }

  // Method to get system grand total (sum of all system totals)
  getSystemGrandTotal(): number {
    return this.serviceListFormArray.controls.reduce(
      (sum, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const systemTotal =
          value.systemTotal != null ? Number(value.systemTotal) : 0;
        const result = sum + systemTotal;
        return Number(result.toFixed(2));
      },
      0,
    );
  }

  // Method to get PDA grand total (sum of all PDA approved values)
  getPdaGrandTotal(): number {
    return this.serviceListFormArray.controls.reduce(
      (sum, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const pdaTotal =
          value.pdaApprovedTotalValue != null
            ? Number(value.pdaApprovedTotalValue)
            : 0;
        const result = sum + pdaTotal;
        return Number(result.toFixed(2));
      },
      0,
    );
  }
  /* ** Needs to be reviewed with Team - PDA comments to be displayed in FDA -- Surjit
  getPdaRemark(serviceName: string): string {
    if (!this.PDAapprovedValue?.items) return '';
    const pdaService = this.PDAapprovedValue.items.find(item => item.service === serviceName);
    return pdaService?.pa_remark || '';
  }
   
  getPdaFeedback(serviceName: string): string {
    if (!this.PDAapprovedValue?.items) return '';
    const pdaService = this.PDAapprovedValue.items.find(item => item.service === serviceName);
    return pdaService?.meraki_feedback || '';
  }
   
  getPdaMerakiRemarkClient(serviceName: string): string {
    if (!this.PDAapprovedValue?.items) return '';
    const pdaService = this.PDAapprovedValue.items.find(item => item.service === serviceName);
    return pdaService?.meraki_remark_client || '';
  }
   
  getPdaClientComment(serviceName: string): string {
    if (!this.PDAapprovedValue?.items) return '';
    const pdaService = this.PDAapprovedValue.items.find(item => item.service === serviceName);
    return pdaService?.client_comment || '';
  }
  */
  isDifferenceFlag(row: any) {
    if (
      Number(row.get('systemTotal')?.value) < Number(row.get('total')?.value) &&
      (!this.withPda ||
        (this.withPda && row.get('agreedOrNegotiate')?.value !== 'Agreed'))
    ) {
      return true;
    } else {
      return false;
    }
  }

  upload(): void {
    const disbursementId = this.fdaEditData?.disbursement_id;
    const disbursementSeq = this.fdaEditData?.disbursement_seq;

    const fdaId = this.fdaEditData?.fda.fda_id;
    const data = {
      files: [],
      disbursementId,
      fdaId,
      pdaOrFda: 'FDA',
      disbursement_seq: disbursementSeq,
      isDisbursement: false,
      source_type: 'Meraki',
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '96vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(FileUploadDisComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
      }
    });
  }

  downloadReport() {
    const report_type = 'FDA';
    const reportData = {
      disbursement_seq: this.fdaEditData.disbursement_seq,
      report_type: report_type,
    };
    this.loader.show();
    this.fileUploadService
      .downloadReport(reportData, this.fdaEditData?.disbursement_id)
      .subscribe({
        next: (res) => {
          this.loader.hide();
        },
        error: (error) => {
          this.loader.hide();
          this.errMsg =
            error.message || 'Something went wrong please try again later.';
          this.snackBar.error(this.errMsg);
        },
      });
  }

  getUploadedFiles(): Observable<any> {
    const data = {
      disbursement_seq: this.fdaEditData?.disbursement_seq,
      pda_fda_flag: 'FDA',
    };
    return this.fileUploadService.fileDataFromDb(data).pipe(
      map((res) => {
        this.fileList = res;
        return res;
      }),
      catchError((err) => {
        this.errMsg =
          err?.error?.error || 'Something went wrong. Please try again later.';
        this.snackBar.error(this.errMsg);
        return of([]);
      }),
    );
  }

  isFormValidExcept(fieldsToIgnore: string[]): boolean {
    return Object.keys(this.portAgentForm.controls).every((key) => {
      if (fieldsToIgnore.includes(key)) return true;

      const control = this.portAgentForm.get(key);

      if (!control) return true;

      // Ignore disabled controls
      if (control.disabled) return true;

      return control.valid;
    });
  }

  // Getter for fromCurrency
  get fromCurrency(): string {
    return this.portAgentForm?.get('fda_currency_from')?.value || '';
  }

  // Getter for toCurrency
  get toCurrency(): string {
    return this.portAgentForm?.get('fda_currency_to')?.value || '';
  }

  get convertedToCurrency(): string {
    return this.portAgentForm?.get('converted_curr_to')?.value || '';
  }

  get convertedFromCurrency(): string {
    return this.portAgentForm?.get('converted_curr_from')?.value || '';
  }

  // method to calculatr the service total in from and to currencies
  calculateSystemAndAgentValueWithRoe(
    service: AbstractControl,
    type: string,
    conversion_type: string,
  ): number | null {
    const fdaRoe = Number(this.portAgentForm.get('fda_roe')?.value) || 1;
    const pdaRoe =
      Number(this.fdaEditData?.pda?.pda_roe) ||
      Number(this.fdaEditData?.fda?.meraki_pda_data?.pda_roe) ||
      fdaRoe;
    const roe = type === 'pda-approved' ? pdaRoe : fdaRoe;
    const conversion_roe = Number(
      this.portAgentForm.get('conversion_fda_rate')?.value || 1,
    );
    let baseValue: number | null = null;

    // Handle 'ToCurrency' and 'convertedToCurrency'
    if (conversion_type === 'ToCurrency') {
      if (type === 'agent') {
        baseValue = Number(service.value?.total) || null;
      } else if (type === 'system') {
        baseValue = Number(service.value?.systemTotal) || null;
      } else if (type === 'pda-approved') {
        baseValue = Number(service.value?.pdaApprovedTotalValue) || null;
      }
      return baseValue !== null
        ? parseFloat((baseValue * roe).toFixed(2))
        : null;
    } else if (conversion_type === 'convertedToCurrency') {
      if (type === 'agent') {
        baseValue =
          this.fromCurrency === this.convertedFromCurrency
            ? Number(service.value?.total) * conversion_roe || null
            : Number(service.value?.total) * roe * conversion_roe;
      } else if (type === 'system') {
        baseValue =
          this.fromCurrency === this.convertedFromCurrency
            ? Number(service.value?.systemTotal) * conversion_roe || null
            : Number(service.value?.systemTotal) * roe * conversion_roe;
      } else if (type === 'pda-approved') {
        baseValue =
          this.fromCurrency === this.convertedFromCurrency
            ? Number(service.value?.pdaApprovedTotalValue) * conversion_roe ||
              null
            : Number(service.value?.pdaApprovedTotalValue) *
              roe *
              conversion_roe;
      }
      return baseValue !== null ? parseFloat(baseValue.toFixed(2)) : null; // Convert to 'convertedToCurrency'
    }

    return null;
  }

  getSystemAndAgentTotal(type: string, conversion_type: string): number | null {
    const fdaRoe = Number(this.portAgentForm.get('fda_roe')?.value) || 1;
    const pdaRoe =
      Number(this.fdaEditData?.pda?.pda_roe) ||
      Number(this.fdaEditData?.fda?.meraki_pda_data?.pda_roe) ||
      fdaRoe;
    const conversionRate =
      Number(this.portAgentForm.get('conversion_fda_rate')?.value) || 1;

    let total = null;

    if (conversion_type === 'ToCurrency') {
      if (type === 'system') {
        const systemTotal = this.getSystemGrandTotal() || null;
        total = systemTotal !== null ? systemTotal * fdaRoe : null;
      } else if (type === 'agent') {
        const agentTotal = this.agentServiceGrandTotal || null;
        total = agentTotal !== null ? agentTotal * fdaRoe : null;
      } else if (type === 'pda-approved') {
        const pdaTotal = this.getPdaGrandTotal() || null;
        total = pdaTotal !== null ? pdaTotal * pdaRoe : null;
      }
    } else if (conversion_type === 'convertedToCurrency') {
      if (type === 'system') {
        const systemTotal = this.getSystemGrandTotal() || null;
        if (this.convertedFromCurrency !== this.fromCurrency) {
          total =
            systemTotal !== null ? systemTotal * fdaRoe * conversionRate : null;
        } else {
          total = systemTotal !== null ? systemTotal * conversionRate : null;
        }
      } else if (type === 'agent') {
        const agentTotal = this.agentServiceGrandTotal || null;
        if (this.convertedFromCurrency !== this.fromCurrency) {
          total =
            agentTotal !== null ? agentTotal * fdaRoe * conversionRate : null;
        } else {
          total = agentTotal !== null ? agentTotal * conversionRate : null;
        }
      } else if (type === 'pda-approved') {
        const pdaTotal = this.getPdaGrandTotal() || null;
        if (this.convertedFromCurrency !== this.fromCurrency) {
          total = pdaTotal !== null ? pdaTotal * pdaRoe * conversionRate : null;
        } else {
          total = pdaTotal !== null ? pdaTotal * conversionRate : null;
        }
      }
    }

    return total !== null ? parseFloat(total.toFixed(2)) : null;
  }

  // method to get the meraki total amount
  getMerakiPdaAmount(): number | null {
    const roe = Number(this.portAgentForm.get('pda_roe')?.value) || 1;
    const conversionRate =
      Number(this.portAgentForm.get('conversion_pda_rate')?.value) || 1;
    if (this.portAgentForm.get('pmt_curr_from')?.value === this.fromCurrency) {
      return this.merakiServiceGrandTotal;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value === this.toCurrency
    ) {
      return this.merakiServiceGrandTotal !== null
        ? this.merakiServiceGrandTotal * roe
        : null;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value ===
        this.convertedToCurrency &&
      this.convertedFromCurrency === this.fromCurrency
    ) {
      return this.merakiServiceGrandTotal !== null
        ? this.merakiServiceGrandTotal * conversionRate
        : null;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value ===
        this.convertedToCurrency &&
      this.convertedFromCurrency === this.toCurrency
    ) {
      return this.merakiServiceGrandTotal !== null
        ? this.merakiServiceGrandTotal * roe * conversionRate
        : null;
    }
    return null;
  }

  shouldShowConvertedCurrencyMarquee(): boolean {
    const form = this.portAgentForm;
    return !!(
      form.get('converted_curr_from')?.value &&
      form.get('converted_curr_to')?.value &&
      form.get('conversion_fda_rate')?.value &&
      (form.get('converted_curr_from')?.value !==
        form.get('fda_currency_from')?.value ||
        form.get('converted_curr_to')?.value !==
          form.get('fda_currency_to')?.value)
    );
  }

  calculateCurrencyConversionForComparison(): void {
    const pmtCurrFrom = this.portAgentForm.get('pmt_curr_from')?.value;
    const roe = this.portAgentForm.get('fda_roe')?.value;
    const fdaConversionRoe = this.portAgentForm.get(
      'conversion_fda_rate',
    )?.value;
    const conversionRate =
      +this.portAgentForm.get('conversion_rate')?.value || null;

    if (this.agentServiceGrandTotal === null || conversionRate === null) {
      this.calculatedCurrencyConversion = null;
      return;
    }

    let calculatedValue: number | null = null;

    if (this.fromCurrency === pmtCurrFrom) {
      calculatedValue = this.agentServiceGrandTotal * conversionRate;
    } else if (this.toCurrency === pmtCurrFrom) {
      calculatedValue = this.agentServiceGrandTotal * roe * conversionRate;
    } else if (
      this.convertedToCurrency === pmtCurrFrom &&
      this.convertedFromCurrency === this.toCurrency
    ) {
      calculatedValue =
        this.agentServiceGrandTotal * roe * fdaConversionRoe * conversionRate;
    } else if (this.convertedToCurrency === pmtCurrFrom) {
      calculatedValue =
        this.agentServiceGrandTotal * fdaConversionRoe * conversionRate;
    }

    this.calculatedCurrencyConversion =
      calculatedValue !== null ? Number(calculatedValue).toFixed(2) : null;
  }

  checkCurrencyConversionMismatch(): void {
    // Only show banner if FDA status is COMPLETED (status 7)
    if (this.fdaStatus !== 7) {
      this.showCurrencyConversionMismatchBanner = false;
      return;
    }

    // Only check for mismatch on initial load
    if (!this.isInitialLoad) {
      return;
    }

    if (
      this.responseCurrencyConversion !== null &&
      this.calculatedCurrencyConversion !== null
    ) {
      const calculated = parseFloat(this.calculatedCurrencyConversion);
      const fromResponse = parseFloat(
        this.responseCurrencyConversion.toString(),
      );
      const hasMismatch = Math.abs(calculated - fromResponse) > 0.01;

      if (hasMismatch) {
        this.showCurrencyConversionMismatchBanner = true;
      }
    }
  }

  // method to refresh tariff rules with warning dialog
  refreshTariffRules() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Replace Tariff Rules',
        text: 'Are you sure you want to replace the current FDA tariff with the latest tariff from the repository? Please note this would also remove the additional vessel property data.',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.fetchPortTariffRulesAndRecalculate();
      }
    });
  }

  // method to fetch port tariff rules and recalculate
  private fetchPortTariffRulesAndRecalculate() {
    const portId = this.portAgentForm.get('port_id')?.value;
    if (!portId) {
      this.snackBar.error('Port is required to fetch tariff rules');
      return;
    }

    // Set flag to indicate we're refreshing rules
    this.isRefreshingRules = true;

    // Use existing method to fetch tariff rules
    this.tariffrulesByPort(portId);

    this.snackBar.success('Tariff rules refreshed successfully');
  }

     isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
